import * as React from 'react';
import { Link } from 'react-router-dom';
import { Icon, Input, Dropdown, Dimmer, Checkbox, Grid, Button } from 'semantic-ui-react';
// import Group from '../sys/group-set';
import UpdateList from '../sys/updateList';
import { default as Renderers } from '../sys/columns';
import  PortalView from './portal';
import MIMEHeaderView from './mimeHeader';
import MediaFileView from './media-file-stats';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import OAuth, { DataExportView, OAuthClientStatus } from '../api';
import SetFilter from '../sys/setFilter';
import ManifestView from './manifest';
import ScanScheduleControl from '../sys/ScanScheduleControl';
import * as ReactTooltip from 'react-tooltip';
import TextView from './textTracks';

const _ = require('lodash');
const FontAwesome = require('react-fontawesome');

class State {
    host: string;
    imgurl: string;
    columns: Array<string>;
    groupby: Array<string>;
    veristream: {};
    showAssets: boolean;
    censusFilter: string | null;
    streamId: number;
    streamIdForPopup: number;
    streamName: string;
    streamNameForPopup: string;
    url: string;
    showTextTracksWindow: boolean;
    showMIMEHeaderWindow: boolean;
    showMediaFileWindow: boolean;
    showManifestWindow: boolean;
    setFilter ?: any;
    statusFilter ?: any;
    formatFilter ?: any;
    initiatorFilter ?: any;
    showTopLevel ?: boolean;
    refreshRate ?: number;
    tempRefreshRate ?: number;
    mode?: string;
    sharedManifest ?: boolean;
    streamType ?: string;
    masterFile ?: boolean;
    treeOrder ?: boolean;
    audioEnabled ?: boolean;
    videoEnabled ?: boolean;
    pixelEnabled ?: boolean;
}

interface Props {
}

export default class CensusView extends React.Component<Props, State> {

    protected columnSets = {
        // the underscore set are always added to the View at the beginning.
        _: [{
                width: 40,
                align: 'center',
                id: 'firstColActions',
                sortable: false,
                Cell: (props: any) => this.buttonRenderer(props)
            }, {
                width: 40,
                align: 'center',
                id: 'statusCol',
                sortable: false,
                Cell: (props: any) => this.statusRenderer(props)
            }, {
                Header: () => this.headerRenderer('Stream', 'Stream name'), // (<div data-tip="Stream Text">Stream</div>),   //{this.tooltipRenderer()}Stream</span>),
                id: 'streamName',
                accessor: 'status.name',
                width: 500,
                aggregate: 'blank',
                resizable: true,
                sortable: true,
                Cell: (props: any) => this.assetNameRenderer(props)
            }
        ],
        Summary: [
            {
                Header: '',
                id: 'imageThumbnail',
                accessor: 'statistics.qoe.thumbnail',
                width: 60,
                aggregate: 'blank',
                resizable: false,
                sortable: false,
                Cell: (props: any) => {
                    if (props.original.statistics.qoe.videoEnabled === true || props.original.statistics.qoe.audioEnabled === true) {
                        return this.thumbnailRenderer(props);
                    } else {
                        let spanStyle = {
                            'display': 'flex',
                            'justifyContent': 'center'
                        };
                        return (<span style={spanStyle}>-</span>);
                    }
                }
            }, {
                Header: () => this.headerRenderer('Initiator', 'Initiator of the stream - Scanner, Scheduler, User, Auto Start'),
                id: 'initiator',
                accessor: 'status.client',
                width: 100,
                aggregate: 'blank',
                align: 'center',
                resizable: false,
                sortable: false,
                Cell: (props: any) => this.initiatorRenderer(props.value)
            }, {
                Header: () => this.headerRenderer('Stream Type', 'ABR format of the stream'),
                accessor: 'status.mediaType',
                id: 'streamType',
                width: 250,
                resizable: false,
                // Cell: (props: any) => Renderers.tooltip(props.value),
                aggregate: 'blank',
            }, {
                Header: () => this.headerRenderer('Duration', 'Active time of test session (dd:hh:mm:ss)'),
                accessor: 'statistics.general.age',
                id: 'duration',
                width: 130,
                resizable: false,
                align: 'right',
                //   aggregate: 'min-max',
                Cell: (props: any) => Renderers.timestamp.duration(props.value)
            }, {
                Header: () => this.headerRenderer((<span>Session<br/>Availability</span>), 'Type: Calculated metric <br /> Period: Session lifetime <br /> Detail: Streaming session availability'),
                id: 'sessionAvailability',
                accessor: (a: any) => a.statistics.general.monitoredSecs !== undefined ? this.getAvailabilityPercentage(a.statistics.general.monitoredSecs, a.statistics.general.erroredSecs) : '-',
                // type: 'availability.sessionPercentOverTotals',
                width: 120,
                resizable: false,
                align: 'right',
                aggregate: 'blank',
                Cell: (data: any) => (data.value !== '-' ? data.value < 0 ? 'N/A' : data.value.toFixed(1).toLocaleString() + '%' : '-')
            }, {
                Header: () => this.headerRenderer((<span>15-Minute<br/>Availability</span>), 'Type: Calculated metric <br /> Period: 15-min sliding window <br /> Detail: 15-min streaming availability'),
                id: '15MinuteAvailability',
                accessor: (a: any) => a.statistics.general.monitoredSec15Win !== undefined ? this.getAvailabilityPercentage(a.statistics.general.monitoredSec15Win, a.statistics.general.erroredSec15Win) : '-',
                // type: 'availability.win15PercentOverTotals',
                width: 120,
                resizable: false,
                align: 'right',
                aggregate: 'blank',
                Cell: (data: any) => (data.value !== '-' ? data.value < 0 ? 'N/A' : data.value.toFixed(1).toLocaleString() + '%' : '-')
            }, {
                Header: () => this.headerRenderer((<span>Stream<br/>Outages</span>), '[Outage/Seconds] <br /> Type: Count <br /> Period: Session lifetime <br /> Detail: Outage events and seconds'),
                accessor: 'statistics.general.outage',
                id: 'streamOutage',
                width: 80,
                align: 'right',
                Cell: (props: any) => this.outageRenderer(props, true),
                aggregate: 'blank',
                sortable: false
            }
        ],
        Accessibility: [
            {
                Header: () => this.headerRenderer((<span>Server <br/>Changes</span>), '[Manifest] / [Media] <br /> Type: Count <br /> Period: Session lifetime <br /> Detail: Session moved to different server IP'),
                accessor: 'statistics.connection',
                id: 'serverChanges',
                width: 100,
                align: 'right',
                Cell: (props: any) => this.serverChangeRenderer(props),
                aggregate: 'blank',
                sortable: false
            }, {
                Header: () => this.headerRenderer((<span>DNS<br/>Time<br/>(ms)</span>), 'Type: Timed <br /> Period: Most recent <br /> Detail: DNS resolution time'),
                accessor: 'statistics.connection.dns.time.current',
                id: 'dnsTime',
                width: 70,
                align: 'right',
                Cell: (props: any) => this.commonTimeRenderer(props, 0x00000040, 0),
                aggregate: 'blank'
            }, {
                Header: () => this.headerRenderer((<span>DNS Time<br/>Error 15M</span>), 'Type: Count <br /> Period: Current 15-min interval <br /> Detail: DNS queries exceeding time threshold'),
                accessor: 'statistics.fifteen.connection.dns.timeErrors',
                Cell: (props: any) => this.commonAlarm0Renderer(props, 0x00000020, 0),
                id: 'dnsTimeError15M',
                width: 105,
                align: 'right',
                aggregate: 'blank'
            }, {
                Header: () => this.headerRenderer((<span>DNS Query<br/>Failure 15M</span>), 'Type: Count <br /> Period: Current 15-min interval <br /> Detail: DNS query failure'),
                accessor: 'statistics.connection.dns.errors',
                id: 'dnsQueryFailure15M',
                width: 105,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.commonAlarm0Renderer(props, 0x00200000, 0),
            }, {
                Header: () => this.headerRenderer((<span>DNS Query<br/>Failure<br/>Window</span>), 'Type: Count  <br /> Period: Sliding window <br /> Detail: DNS query failures'),
                accessor: 'statistics.connection.dns.errorsWindow',
                id: 'dnsQueryFailureWindow',
                width: 105,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.commonAlarmRenderer(props, 0x00000080, 1, false),
            }, {
                Header: () => this.headerRenderer((<span>TCP<br/>Connection<br/>Time (ms)</span>), 'Type: Timed <br /> Period: Most recent <br /> Detail: TCP session establish with server'),
                accessor: 'statistics.connection.time.current',
                id: 'tcpConnectionTime',
                width: 100,
                align: 'right',
                Cell: (props: any) => this.commonTimeRenderer(props, 0x00000008, 0),
                aggregate: 'blank'
            }, {
                Header: () => this.headerRenderer((<span>TCP<br/>Connection<br/>Time 15M</span>), 'Type: Count <br /> Period: Current 15-min interval <br /> Detail: TCP connection attempts exceeding time threshold'),
                accessor: 'statistics.fifteen.connection.timeErrors',
                id: 'tcpConnectionTime15M',
                Cell: (props: any) => this.commonAlarm0Renderer(props, 0x00000004, 0),
                width: 105,
                align: 'right',
                aggregate: 'blank'
            }, {
                Header: () => this.headerRenderer((<span>TCP<br/>Connection<br/>Failure<br/>15M</span>), 'Type: Count <br /> Period: Current 15-min interval <br /> Detail: TCP connection errors'),
                accessor: 'statistics.connection.errors',
                id: 'tcpConnectionFailure15M',
                width: 105,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.commonAlarmRenderer(props, 0x08000000, 1, false),
            }, {
                Header: () => this.headerRenderer((<span>TCP<br/>Connection<br/>Failure<br/>Window</span>), 'Type: Count <br /> Period:  Sliding window <br /> Detail: TCP connection errors'),
                accessor: 'statistics.connection.errorsWindow',
                id: 'tcpConnectionFailureWindow',
                width: 95,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.commonAlarmRenderer(props, 0x00001000, 1, false),
            }, {
                Header: () => (
                    <div>
                        <div className="title">HTTP Status Codes</div>
                        <div className="http totals -header">
                            <div className="http2xxBox-empty">{this.headerRenderer('2xx', 'Type: Count <br /> Period: Session lifetime <br /> Detail: HTTP 2xx (Success) response')}</div>
                            <div className="http3xxBox-empty">{this.headerRenderer('3xx', 'Type: Count <br /> Period: Session lifetime <br /> Detail: HTTP 3xx (Redirect) response')}</div>
                            <div className="http4xxBox-empty">{this.headerRenderer('4xx', 'Type: Count <br /> Period: Session lifetime <br /> Detail: HTTP 4xx (Client error) response')}</div>
                            <div className="http5xxBox-empty">{this.headerRenderer('5xx', 'Type: Count <br /> Period: Session lifetime <br /> Detail: HTTP 5xx (Server error) response')}</div>
                            <div className="outline">{this.headerRenderer('CL', 'Type: Count <br /> Period: Session lifetime <br /> Detail: Close connections - incremented for each explicity close')}</div>
                            <div className="outline">{this.headerRenderer('OT', 'Type: Count <br /> Period: Session lifetime <br /> Detail: Connection errors other than open/close')}</div>
                        </div>
                    </div>
                ),
                accessor: 'statistics.http',
                // type: 'http',
                Cell: (props: any) => this.httpCodesRenderer(props.value),
                id: 'httpStatusCodes',
                width: 500,
                align: 'left',
                className: 'group-first group-last',
                aggregate: 'blank',
                sortable: false
            }, {
                Header: () => this.headerRenderer((<span>HTTP 4xx<br/>Error<br/>15M</span>), 'Type: Count of responses  <br /> Period: Current 15-min interval  <br /> Detail: HTTP 4xx response received'),
                accessor: 'statistics.fifteen.http.hsce4xxTotal',
                Cell: (props: any) => this.commonAlarmRenderer(props, 0x00080000, 0, false),
                id: 'http4XxError15M',
                width: 100,
                align: 'right',
                aggregate: 'blank'
            }, {
                Header: () => this.headerRenderer((<span>HTTP 4xx<br/>Error<br/>Window</span>), 'Type: Count of responses <br /> Period: Sliding window <br /> Detail: HTTP 4xx response received'),
                accessor: 'statistics.http.hsce4xxWindow',
                Cell: (props: any) => this.commonAlarmRenderer(props, 0x00000800, 1, false),
                id: 'http4XxErrorWindow',
                width: 100,
                align: 'right',
                aggregate: 'blank'
            }, {
                Header: () => this.headerRenderer((<span>HTTP 5xx<br/>Error<br/>15M</span>), 'Type: Count of responses <br /> Period: Current 15-min interval  <br /> Detail: HTTP 5xx response received'),
                accessor: 'statistics.fifteen.http.hsse5xxTotal',
                id: 'http5XxError15M',
                width: 100,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.commonAlarmRenderer(props, 0x00020000, 0, false),
            }, {
                Header: () => this.headerRenderer((<span>HTTP 5xx<br/>Error<br/>Window</span>), 'Type: Count of responses <br /> Period: Sliding window <br /> Detail: HTTP 5xx response received'),
                accessor: 'statistics.http.hsse5xxWindow',
                id: 'http5XxErrorWindow',
                width: 100,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.commonAlarmRenderer(props, 0x00000400, 1, false),
            }, {
                Header: () => this.headerRenderer((<span>MIME<br/>Header</span>), 'Type: Count of occurrences  <br /> Period: Session Lifetime <br /> Detail: Unexpected or not present MIME Header fields in response'),
                accessor: 'statistics.connection.mimeHeaderErrors',
                id: 'mimeHeader',
                width: 70,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.commonAlarmRenderer(props, 0x00002000, 1, true)
            }
        ],
        ['ABR Protocol']: [
            {
                Header: () => this.headerRenderer((<span>Playlist<br/>Unavailable</span>), 'Type: Count of occurrences<br/>Period: Session Lifetime<br/>Detail: Playlist file unavailable for download after configured number of retries'),
                accessor: 'statistics.files.manifest.unaErr', // '/ unaConsErr'
                id: 'playlistUnavailable',
                width: 95,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.commonAlarmRenderer(props, 0x00000200, 1, false)
            }, {
                Header: () => this.headerRenderer((<span>Playlist<br/>File<br/>Error</span>), 'Type: Count of occurrences <br /> Period: Session Lifetime <br /> Detail: Mandatory fields not present in playlist'),
                accessor: 'statistics.fifteen.files.manifest.fileErr',
                id: 'playlistFileError',
                width: 70,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.commonAlarmRenderer(props, 0x00200000, 1, false)
            }, {
                Header: () => this.headerRenderer((<span>Playlist<br/>Stall</span>), 'Type: Count of occurrences <br /> Period: Session Lifetime <br /> Detail: Playlist not updating as expected'),
                accessor: 'statistics.files.manifest.stallErr',
                id: 'playlistStall',
                width: 70,
                align: 'right',
                Cell: (props: any) => this.checkMaster(props, 0x00002000, 0),
                aggregate: 'blank'
            }, {
                Header: () => this.headerRenderer((<span>Missing<br/>Variants</span>), 'Type: Count <br /> Period: Most recent playlist/manifest <br /> Detail: Missing variants based on Alarm Template definition'),
                accessor: 'statistics.files.manifest.varReqCnt',
                id: 'missingVariants',
                width: 70,
                align: 'right',
                Cell: (props: any) => this.checkVariant(props, 0x00000004, 1, 'missing'),
                aggregate: 'blank'
            },  {
                Header: () => this.headerRenderer((<span>Variant<br/>Count<br/>Error</span>), 'Type: Count of occurrences <br /> Period: Session Lifetime <br /> Detail: Number of playlists where expected profiles differs from the actual value'),
                accessor: 'statistics.files.manifest.profCntErr',
                id: 'variantCountError',
                width: 70,
                align: 'right',
                Cell: (props: any) => this.commonAlarmRenderer(props, 0x80000000, 1, false),
                aggregate: 'blank'
            }, {
                Header: () => this.headerRenderer((<span>Variant<br/>Required<br/>Error</span>), 'Type: Count <br /> Period: 15-min interval <br /> Detail: Playlist does not contain all expected variants'),
                accessor: 'statistics.files.manifest.varReqErr',
                id: 'variantRequiredError',
                width: 70,
                align: 'right',
                Cell: (props: any) => this.checkVariantOrig(props, 'total'),
                aggregate: 'blank'
            }, {
                Header: () => this.headerRenderer((<span>Media File<br/>Unavailable</span>), 'Type: Count <br /> Period: Sliding window <br /> Detail: Media file unavailable for download after multiple retries'),
                accessor: 'statistics.files.media.unaErrWin',
                id: 'mediaFileUnavailable',
                width: 100,
                align: 'right',
                Cell: (props: any) => this.checkMaster(props, 0x00000100, 1),
                aggregate: 'blank'
            }, {
                Header: () => this.headerRenderer(
                    (<span>Media Time<br/>Deviation<br/>(sec)</span>),
                    'Type: Calculated, DASH streams with segment timeline only <br /> Period: Most recent MPD <br /> Detail:  Time deviation between media live edge and MPD segment timeline exceeds configured threshold.'
                ),
                accessor: 'statistics.files.media.mediaTimeDev.current',
                id: 'mediaTimeDeviation',
                width: 100,
                align: 'right',
                Cell: (props: any) => this.checkNA(props, 0x00000010, 0, false),
                aggregate: 'blank'
            }, {
                Header: () => this.headerRenderer((<span>Sequence<br/>Error<br/>Contiguous</span>), 'Type: Count <br /> Period: Session Lifetime <br /> Detail:  Two or more consecutive media file sequence number are not sequential'),
                accessor: 'statistics.files.media.sequence.contiguousErrors',
                id: 'sequenceErrorContiguous',
                width: 90,
                align: 'right',
                Cell: (props: any) => this.checkMaster(props, 0x01000000, 0),
                aggregate: 'blank'
            }, {
                Header: () => this.headerRenderer((<span>Sequence<br/>Error<br/>15M</span>), 'Type: Count <br /> Period: Current 15-min interval <br /> Detail: Media file sequence number are not sequential'),
                accessor: 'statistics.fifteen.files.media.sequence.errors',
                id: 'sequenceError15M',
                width: 85,
                align: 'right',
                Cell: (props: any) => this.checkMaster(props, 0x00800000, 0),
                aggregate: 'blank'
            }, {
                Header: () => this.headerRenderer((<span>Sequence<br/>Error<br/>Total</span>), 'Type: Count <br /> Period: Session Lifetime <br /> Detail: Media file sequence number are not sequential'),
                accessor: 'statistics.files.media.sequence.errors',
                id: 'sequenceErrorTotal',
                width: 85,
                align: 'right',
                Cell: (props: any) => this.checkMaster(props, 0x02000000, 0),
                aggregate: 'blank'
            }, {
                Header: () => this.headerRenderer((<span>Media File<br/>Duration Error<br/>15M</span>), 'Type: Count <br /> Period: Current 15-min interval <br /> Detail: Media file playback duration exceed the specified threshold'),
                accessor: 'statistics.fifteen.files.media.durationMaxErrors',
                id: 'mediaFileDurationError15M',
                width: 110,
                align: 'right',
                Cell: (props: any) => this.checkMaster(props, 0x00008000, 0),
                aggregate: 'blank'
            }, {
                Header: () => this.headerRenderer((<span>Media File<br/>Bitrate Error<br/>15M</span>), 'Type: Count <br /> Period: Current 15-min interval <br /> Detail: Media file bitrate does not match the advertised value'),
                accessor: 'statistics.fifteen.files.media.bitrateErrors',
                id: 'mediaFileBitrateError15M',
                width: 105,
                align: 'right',
                Cell: (props: any) => this.checkMaster(props, 0x20000000, 1),
                aggregate: 'blank'
            }, {
                Header: () => this.headerRenderer((<span>Media File<br/>Time Not<br/>Aligned</span>), 'Type: Count <br /> Period: Session lifetime <br /> Detail: Media file alignment timing incorrect'),
                accessor: 'statistics.files.media.mftaCntErr',
                id: 'mediaFileTimeNotAligned',
                width: 100,
                align: 'right',
                Cell: (props: any) => this.checkNotMaster(props, 0x00010000, 0),
                aggregate: 'blank'
            }, {
                Header: () => this.headerRenderer((<span>I-Frame<br/>Missing</span>), 'Type: Count <br /> Period: Session Lifetime <br /> Detail: Each media file that does not start with an I-Frame'),
                accessor: 'statistics.qoe.errors.frameStartErr',
                id: 'iFrameMissing',
                width: 105,
                align: 'right',
                Cell: (props: any) => this.checkMaster(props, 0x00000002, 0),
                aggregate: 'blank'
            }, {
                Header: () => this.headerRenderer((<span>Audio<br/>Not<br/>Present</span>), 'Type: Count, Apple & MPEG DASH MPEG-2 media only <br /> Period: Session <br /> Detail:  Media files contains no audio PID'),
                accessor: 'statistics.files.media.audio.NPErrors',
                id: 'audioNotPresent',
                width: 70,
                align: 'right',
                Cell: (props: any) => this.checkNA(props, 0x00000400, 0, false),
                aggregate: 'blank',
                sortable: false
            }, {
                // tslint:disable-next-line:max-line-length
                Header: () => this.headerRenderer((<span>Video/Audio<br/>Sync<br/>Error</span>), 'Type: Count, Microsoft Smooth Stream Only <br /> Period: Session <br /> Detail: Video/audio are considered out of sync as measured by the video/audio synchronization threshold'),
                accessor: 'statistics.files.media.video.videoAudioSyncErrors',
                id: 'videoAudioSyncError',
                width: 100,
                align: 'right',
                Cell: (props: any) => this.checkNA(props, 0x00001000, 0, false),
                aggregate: 'blank'
            }, {
                Header: () => this.headerRenderer((<span>Decryption<br/>Error</span>), 'Type: Count, Apple AES Only <br /> Period: Session <br /> Detail: Media files that contain sync byte errors and/or missing PIDs after decryption'),
                accessor: 'statistics.files.media.decrypt.errors',
                id: 'decryptionError',
                width: 90,
                align: 'right',
                Cell: (props: any) => this.checkNA(props, 0x00000800, 0, true),
                aggregate: 'blank'
            }
        ],
        ['Streaming Performance / Delivery']: [
            {
                Header: () => this.headerRenderer((<span>Media<br/>Files</span>), 'Type: Count <br /> Period: Session lifetime <br /> Detail: Downloaded media files'),
                accessor: 'statistics.files.media.download.rate.samples',
                id: 'mediaFiles',
                width: 70,
                align: 'right',
                Cell: (props: any) => this.commaRenderer(props),
                aggregate: 'blank'
            }, {
                Header: () => this.headerRenderer((<span>Current<br/>Sequence</span>), 'Current media file sequence or fragment number'),
                accessor: 'statistics.files.media.sequence.current',
                id: 'currentSequence',
                width: 105,
                align: 'right',
                Cell: (props: any) => this.checkMasterRenderer(props, false),
                aggregate: 'blank'
            }, {
                Header: () => this.headerRenderer((<span>Total<br/>KBytes<br/>Downloaded</span>), 'Type: Sum <br /> Period: Session lifetime <br /> Detail: Kilobytes of media files downloaded'),
                accessor: 'statistics.files.media.totalBytes',
                id: 'totalKbytesDownloaded',
                width: 100,
                align: 'right',
                Cell: (props: any) => this.bytesToKbRenderer(props),
                aggregate: 'blank'
            }, {
                Header: () => this.headerRenderer((<span>Media<br/>Bitrate<br/>(kbps)</span>), 'Type: Calculated <br /> Period: Most recent media file <br /> Detail: Encoded bitrate'),
                accessor: 'statistics.files.media.bitrate.current',
                id: 'mediaBitrate',
                width: 100,
                align: 'right',
                Cell: (props: any) => this.bytesToKbRenderer(props),
                aggregate: 'blank'
            }, {
                Header: () => this.headerRenderer((<span>Download<br/>Bitrate<br/>(kbps)</span>), 'Type: Calculated <br /> Period: Most recent media file <br /> Detail: Download rate'),
                accessor: 'statistics.files.media.download.rate.current',
                id: 'downloadBitrate',
                width: 100,
                align: 'right',
                Cell: (props: any) => this.renderBitRate(props),
                aggregate: 'blank'
            }, {
                Header: () => this.headerRenderer(
                    (<span>Video<br/>Start<br/>Failure</span>),
                    'Type: Count <br /> Period: Session start - optionally recalculated every 15-min <br /> Detail: Video Start Failure - Time from session start to first media file download exceeds threshold'
                ),
                accessor: 'statistics.timing.vsf',
                id: 'videoStartFailure',
                width: 85,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.commonAlarmRenderer(props, 0x02000000, 1, false),
            }, {
                // tslint:disable-next-line:max-line-length
                Header: () => this.headerRenderer((<span>Derived<br/>Variant Start<br/>Time (ms)</span>), 'Type: Timed <br /> Period: Session startup - optionally recalculated every 15-min <br /> Detail: Time from session start until predicted playback start'),
                accessor: 'statistics.timing.dvst',
                id: 'derivedVariantStartTime',
                width: 120,
                align: 'right',
                Cell: (props: any) => this.checkMaster(props, 0x00800000, 1),
                aggregate: 'blank'
            }, {
                Header: () => this.headerRenderer(
                    (<span>Derived<br/>Variant<br/>Start<br/>Time<br/>Exceeded</span>),
                    'Type: Count  <br /> Period: Session start - optionally recalculated every 15-min <br /> Detail: Derived Video Start Time - Predicted playback start exceeds time threshold'
                ),
                Cell: (props: any) => this.checkMaster(props, 0x00800000, 1),
                accessor: 'statistics.timing.dvstErr',
                id: 'derivedVariantStartTimeExceeded',
                width: 120,
                align: 'right',
                aggregate: 'blank'
            },  {
                Header: () => this.headerRenderer((<span>Buffer / Gear <br/>Change %</span>), 'Type: Calculated <br /> Period: Session lifetime <br /> Detail: Percent of time in buffer/gear change state'),
                accessor: 'statistics.veristream.gearChange.ratio',
                id: 'bufferGearChangePercent',
                width: 110,
                align: 'right',
                className: 'color-reverse',
                Cell: (props: any) => this.checkMasterRenderer(props, false),
                aggregate: 'blank'
            }, {
                Header: () => this.headerRenderer((<span>Buffer / Gear <br/>Change<br/>Duration (sec)</span>), 'Type: Total seconds <br /> Period: Session <br /> Detail: Buffering or gear changing due to delivery delays'),
                accessor: 'statistics.veristream.gearChange.riskDurationActive',
                Cell: (props: any) => this.checkMaster(props, 0x00010000, 1),
                id: 'bufferGearChangeDuration',
                width: 105,
                align: 'right',
                aggregate: 'blank'
            }, {
                Header: () => this.headerRenderer((<span>Buffer / Gear<br/>Changes<br/>15M</span>), 'Type: Count <br /> Period: Current 15-min interval <br /> Detail: Predicted buffer events or gear changes'),
                accessor: 'statistics.fifteen.veristream.gearChange.riskEvents',
                Cell: (props: any) => this.checkMaster(props, 0x00008000, 1),
                id: 'bufferGearChanges15M',
                width: 110,
                align: 'right',
                aggregate: 'blank'
            }, {
                Header: () => this.headerRenderer((<span>Buffer / Gear<br/>Changes<br/>Window</span>), 'Type: Count <br /> Period: Sliding window  <br /> Detail: Predicted buffer events or gear changes'),
                accessor: 'statistics.veristream.gearChange.riskEventsWindow',
                Cell: (props: any) => this.checkMaster(props, 0x00000040, 1),
                id: 'bufferGearChangesWindow',
                width: 110,
                align: 'right',
                aggregate: 'blank'
            }, {
                Header: () => this.headerRenderer((<span>Download<br/>Time<br/>Exceeded<br/>Total</span>), 'Type: Count <br /> Period: Session lifetime <br /> Detail: Media file download time exceed playback duration'),
                accessor: 'statistics.files.media.dltErr',
                id: 'downloadTimeExceededTotal',
                width: 105,
                align: 'right',
                Cell: (props: any) => this.checkMaster(props, 0x00004000, 0),
                aggregate: 'blank'
            }, {
                Header: () => this.headerRenderer((<span>Download<br/>Time<br/>Exceeded<br/>Window</span>), 'Type: Count  <br />  Period: Sliding window <br /> Detail: Media file download time exceed playback duration'),
                accessor: 'statistics.files.media.dltErrWin',
                id: 'downloadTimeExceededWindow',
                width: 105,
                align: 'right',
                Cell: (props: any) => this.checkMaster(props, 0x00004000, 0),
                aggregate: 'blank'
            }, {
                Header: () => (
                    <div>
                        <div className="title">VeriStream Distribution</div>
                        <div className=" totals -header">
                            <div className="vs5-empty">
                                {this.headerRenderer('5', 'Type: Calculated <br /> Period: Session lifetime <br /> Detail: Balanced System - media segments delivered at expected rate to satisfy media buffer and playback')}
                            </div>
                            <div className="vs4-empty">{this.headerRenderer('4', 'Type: Calculated <br /> Period: Session lifetime <br /> Detail: Growing Buffer -  media segments delivered fast enough to sustain intermittent network delays')}</div>
                            {/* tslint:disable-next-line:max-line-length */}
                            <div className="vs3-empty">
                                {this.headerRenderer('3', 'Type: Calculated <br /> Period: Session lifetime <br /> Detail: Warning - media segment delivery is not filling media buffer, lowering clients ability to handle network delays')}
                            </div>
                            <div className="vs2-empty">{this.headerRenderer('2', 'Type: Calculated <br /> Period: Session lifetime <br /> Detail: Underrun - sustained periods result in degraded playback experience')}</div>
                            {/* tslint:disable-next-line:max-line-length */}
                            <div className="vs1-empty">{this.headerRenderer('1', 'Type: Calculated <br /> Period: Session lifetime <br /> Detail: Severe Underrun - sustained periods result in degraded playback experience and additional recovery time')}</div>
                        </div>
                    </div>
                ),
                accessor: 'statistics.veristream.totals',
                type: 'totals',
                id: 'veristreamDistribution',
                width: 270,
                align: 'left',
                className: 'group-first group-last',
                aggregate: 'blank',
                sortable: false
            }, {
                Header: () => this.headerRenderer((<span>VeriStream<br/>(last 20 segments)</span>), 'Type: Calculated <br /> Period: Session lifetime <br /> Detail: VeriStream score of 20 most recent media files - leftmost chicklet is most recent'),
                accessor: 'status.streamid',
                id: 'veristreamLast20Segments',
                width: 205,
                align: 'center',
                className: 'group-first group-last',
                Cell: (props: any) => {
                    const v = this.state.veristream && this.state.veristream[props.value];
                    return Renderers.veristream.chicklets({ value: v });
                },
                aggregate: 'blank',
                sortable: false
            }, {
                Header: () => this.headerRenderer((<span>VeriStream<br/>Error<br/>Period</span>), 'Type: Count <br /> Period: Session Lifetime <br /> Detail: VeriStream value crosses below the error threshold value'),
                accessor: 'statistics.veristream.errorPeriod.events',
                // type: 'availability.outage',
                Cell: (props: any) => this.checkMaster(props, 0x80000000, 0),
                id: 'veristreamErrorPeriod',
                width: 100,
                align: 'right',
                aggregate: 'blank'
            }, {
                Header: () => this.headerRenderer((<span>VeriStream<br/>Threshold<br/>Cross 15M</span>), 'Type: Count  <br /> Period: Current 15-min interval <br /> Detail: VeriStream value crosses below the error threshold value'),
                accessor: 'statistics.fifteen.veristream.errorPeriod.events',
                // type: 'availability.outage',
                Cell: (props: any) => this.checkMaster(props, 0x20000000, 0),
                id: 'veristreamThresholdCross15M',
                width: 100,
                align: 'right',
                aggregate: 'blank'
            }, {
                Header: () => this.headerRenderer(
                    (<span>VeriStream<br/>Err Period<br/>Current</span>),
                    'VeriStream Error Period Current<br/>Type: Count<br/>Period: Most Recent Error Period<br/>Detail: Consecutive media segments below VeriStream threshold'
                ),
                accessor: 'statistics.veristream.errorPeriod.current',
                Cell: (props: any) => this.checkNARenderer(props),
                id: 'veristreamErrPeriodCurrent',
                width: 100,
                align: 'right',
                aggregate: 'blank'
            }, {
                // tslint:disable-next-line:max-line-length
                Header: () => this.headerRenderer((<span>VeriStream<br/>ED<br/>Current</span>), 'VeriStream Error Distance Current<br/>Type: Count<br/>Period: Since last VeriStream error<br/>Detail: Consecutive media segments above VeriStream threshold since last media segment below VeriStream threshold'),
                accessor: 'statistics.veristream.errorDistance.current',
                Cell: (props: any) => this.checkNA(props, 0x40000000, 0, true),
                id: 'veristreamEdCurrent',
                width: 100,
                align: 'right',
                aggregate: 'blank'
            }
        ],
        ['Caption/Subtitle']: [
            {
                Header: () => this.headerRenderer((<span>Caption<br/>Count<br/>Error<br/>Window</span>), 'Type: Count <br /> Period: Sliding window <br /> Detail: Caption files with minimum caption entries not present'),
                accessor: 'statistics.files.media.text.caption.countErrWin',
                id: 'captionCountErrorWindow',
                width: 105,
                align: 'right',
                Cell: (props: any) => this.checkMediaType(props, 0x00000020, 1, false),
                aggregate: 'blank'
            }, {
                Header: () => this.headerRenderer((<span>Text<br/>Format<br/>Error<br/>Window</span>), 'Type: Count <br /> Period: Sliding window <br /> Detail: Caption files missing mandatory fields'),
                accessor: 'statistics.files.media.text.format.errWin',
                id: 'textFormatErrorWindow',
                width: 105,
                align: 'right',
                Cell: (props: any) => this.checkMediaType(props, 0x00000010, 1, false),
                aggregate: 'blank'
            }, {
                Header: () => this.headerRenderer((<span>Stalled<br/>Text<br/>Error</span>), 'Type: Count <br /> Period: Session Lifetime <br /> Detail: Caption file is stalled for longer then threshold'),
                accessor: 'statistics.files.media.text.stall.errors',
                id: 'stallTextError',
                width: 105,
                align: 'right',
                Cell: (props: any) => this.checkMediaType(props, 0x00000008, 1, true),
                aggregate: 'blank'
            }
        ],
        ['Media Quality']: [
            {
                Header: () => this.headerRenderer((<span>Video<br/>MOS</span>), 'Type: Average <br /> Period: 10 seconds <br /> Detail: Mean opinion score (1-5) for video content'),
                accessor: 'statistics.qoe.mos.video.current',
                id: 'videoMos',
                width: 70,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.checkQoEMedia(props, 0x00080000, 1)
            }, {
                Header: () => this.headerRenderer((<span>GOP<br/>MOS</span>), 'Type: Calculated <br /> Period: Most recent GOP <br /> Detail: Mean opinion score (1-5)'),
                accessor: 'statistics.qoe.mos.gop.current',
                id: 'gopMos',
                width: 70,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.checkQoEMedia(props, 0x04000000, 1)
            }, {
                Header: () => this.headerRenderer((<span>Black<br/>Screen</span>), 'Type: Percentage / Frames <br /> Period: Most recent video segment <br /> Detail: Percentage of the video frame that is black / # of frames that exceed 90% blackness level in the test cycle'),
                accessor: 'statistics.qoe.gop.blackness.current',
                id: 'blackScreen',
                width: 85,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.checkQoEMedia(props, 0x00040000, 1)
            }, {
                Header: () => this.headerRenderer((<span>Frame<br/>Error</span>), 'Type: Count <br /> Period: Session Lifetime <br /> Detail: Frame errors identified on the media file'),
                accessor: 'statistics.qoe.errors.frameErr',
                id: 'frameError',
                width: 85,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.checkVideoProps(props)
            }, {
                Header: () => this.headerRenderer((<span>Still<br/>Frame</span>), 'Type: Percentage / Frames <br /> Period: Most recent video segment <br /> Detail: Percentage of the video frame without motion / # of frames that are less than 5% motion in the test cycle'),
                accessor: 'statistics.qoe.gop.stillness.current',
                id: 'stillFrame',
                width: 85,
                align: 'right',
                Cell: (props: any) => this.checkQoEMedia(props, 0x00020000, 1),
                aggregate: 'blank'
            }, {
                Header: () => this.headerRenderer((<span>Pixel<br/>Block<br/>Artifact</span>), 'Type: Calculated <br /> Period: Most recent GOP <br /> Detail: Value of blockiness over the decoded frame'),
                accessor: 'statistics.qoe.pixel.pixelGop.current',
                id: 'pixelBlockArtifact',
                width: 70,
                align: 'right',
                Cell: (props: any) => this.checkQoEMedia(props, 0x00100000, 1),
                aggregate: 'blank'
            }, {
                Header: () => this.headerRenderer((<span>Audio<br/>MOS</span>), 'Type: Average <br /> Period: 10 seconds <br /> Detail: Mean opinion score (1-5) for audio content'),
                accessor: 'statistics.qoe.mos.audio.current',
                id: 'audioMos',
                width: 70,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.checkQoEMedia(props, 0x00000002, 1)
            }, {
                Header: () => this.headerRenderer((<span>Loudness</span>), 'Type: Measured average<br/>Period: Last 10 seconds of audio<br/>Detail: Loudness K-weighted relative to full scale'),
                accessor: 'statistics.qoe.audio.loudness.current',
                id: 'loudness',
                width: 85,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.checkQoEMedia(props, 0x01000000, 1)
            }, {
                Header: () => this.headerRenderer((<span>Dialnorm</span>), 'Type: Metadata<br/>Period: Last 10 seconds of audio<br/>Detail: Average dialog normalization level from the media'),
                accessor: 'statistics.qoe.audio.dialnorm.current',
                id: 'dialnorm',
                width: 85,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.checkQoEMedia(props, 0x00000001, 0)
            }, {
                Header: () => this.headerRenderer((<span>Dialnorm<br/>Deviation</span>), 'Type: Calculated<br/>Period: Most recent audio segment<br/>Detail: Measured loudness deviation from the received dialnorm metadata'),
                accessor: 'statistics.qoe.audio.loudnessDnDev.current',
                id: 'dialnormDeviation',
                width: 85,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.checkQoEMedia(props, 0x00000001, 0)
            }, {
                Header: () => this.headerRenderer((<span>Silence</span>), 'Type: Count <br /> Period: Most recent audio segment <br /> Detail: Audio channels detected'),
                accessor: 'status.audioParams.channels',
                id: 'silence',
                width: 85,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.checkQoEMedia(props, 0x00000001, 1)
            }
        ],
        ['Dynamic Ad']: [
            {
                Header: () => this.headerRenderer((<span>Splice<br/>Interval<br/>Time</span>), 'Type: Count of occurrences, Auto-Close <br /> Period: Session Lifetime <br /> Detail: Ad splice events not occurring at configured frequency'),
                accessor: 'statistics.dai.spliceIvlTime.current',
                id: 'spliceIntervalTime',
                width: 85,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.commonMasterTimeRenderer(props, 0x10000000, 0),
            },
            {
                Header: () => this.headerRenderer((<span>Splice<br/>Sequence<br/>Error</span>), 'Type: Count of occurrences, Auto-Close, HLS Only<br/>Period: Session Lifetime<br/>Detail: Ad break without matching OUT and IN splice events'),
                accessor: 'statistics.dai.spliceSeqErr',
                id: 'spliceSequenceError',
                width: 85,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.checkMaster(props, 0x08000000, 0),
            },
            {
                Header: () => this.headerRenderer((<span>Media<br/>Duration<br/>Before<br/>Ad</span>), 'Type: Count of occurrences, Auto-Close <br /> Period: Session Lifetime <br /> Detail: Media duration before ad break is too short'),
                accessor: 'statistics.dai.mfDurMinErr',
                id: 'mediaDurationBeforeAd',
                width: 70,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.checkMaster(props, 0x04000000, 0),
            },
            {
                // tslint:disable-next-line:max-line-length
                Header: () => this.headerRenderer((<span>Playback<br/>Duration<br/>Under<br/>Threshold</span>), 'Type: Count of occurrences, Auto-Close <br /> Period: Session Lifetime <br /> Detail: Media associated with the ad break is under expected duration of the ad break'),
                accessor: 'statistics.dai.adPbdUnrErr',
                id: 'playbackDurationUnderThreshold',
                width: 80,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.checkMaster(props, 0x00400000, 0)
            },
            {
                // tslint:disable-next-line:max-line-length
                Header: () => this.headerRenderer((<span>Playback<br/>Duration<br/>Over<br/>Threshold</span>), 'Type: Count of occurrences, Auto-Close <br /> Period: Session Lifetime <br /> Detail: Media associated with the ad break exceeds  expected duration of the ad break'),
                accessor: 'statistics.dai.adPbdOvrErr',
                id: 'playbackDurationOverThreshold',
                width: 80,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.checkMaster(props, 0x00100000, 0)
            },
            {
                // tslint:disable-next-line:max-line-length
                Header: () => this.headerRenderer((<span>Format<br/>Mismatch<br/>Error</span>), 'Type: Count of occurrences, Auto-Close <br /> Period: Session Lifetime <br /> Detail: Ad format (codec, resolution, sample rate) differs from media format'),
                accessor: 'statistics.dai.adFmtMmErr',
                id: 'formatMismatchError',
                width: 70,
                align: 'right',
                aggregate: 'blank',
                Cell: (props: any) => this.checkMaster(props, 0x00040000, 0)
            }
        ],
        [' ']: [
            {
                // width: 12,
                maxWidth: 12,
                align: 'center',
                id: 'scrollbarBuffer',
                sortable: false,
                // Cell: (props: any) => this.statusRenderer(props)
            }]
};

    private seed: number = 1;

    isSecureSite(): boolean {
        return window.location && window.location.protocol === 'https:';
    }

    random() {
        let x = Math.sin(this.seed++) * 10000;
        return x - Math.floor(x);
    }
    componentWillMount() {
        let host, imgurl, refreshRate, allCols;

        // process shortcuts in the columns sets into fields ready for React Table
        // Renderers.ReactTable(this.columnSets);
        
        // const groupSet = JSON.parse(window.localStorage.getItem('group-set') || '{}');

        const groupSet = {set: ['Summary', 'Accessibility', 'ABR Protocol', 'Streaming Performance / Delivery',
                                    'Caption/Subtitle', 'Media Quality', 'Dynamic Ad', ' ']};

        if (window.localStorage && (refreshRate = window.localStorage.getItem('refreshRate'))) {
            refreshRate = parseInt(refreshRate, 10);
        } else {
            refreshRate = 30000;
            window.localStorage.setItem('refreshRate', JSON.stringify(refreshRate));
        }

        if (window.localStorage && (allCols = window.localStorage.getItem('columns'))) {
            let colsMatch = this.checkColumnsAgainstStoredColumns(this.columnSets, JSON.parse(allCols));
            if (!colsMatch) {
                window.localStorage.removeItem('columns');
            }
        }

        if (window.localStorage && (allCols = window.localStorage.getItem('columns'))) {
            this.setInitialColumns(this.columnSets, JSON.parse(allCols));
        } else {
            this.setDefaultColumns(this.columnSets, true);
        }

        // if (window.localStorage && (showTopLevel = window.localStorage.getItem('showTopLevel'))) {
        //     showTopLevel = parseInt(showTopLevel, 10);
        //     if (showTopLevel === 0) {
        //         showTopLevel = false;
        //         treeOrder = false;
        //     } else {
        //         showTopLevel = true;
        //         treeOrder = true;
        //     }
        // } else {
        //     showTopLevel = false;
        //     treeOrder = false;
        //     window.localStorage.setItem('showTopLevel', JSON.stringify(0));
        // }

        this.setState({
            columns: groupSet.set,
            groupby: [],
            showAssets: false,
            showTextTracksWindow: false,
            showMIMEHeaderWindow: false,
            showMediaFileWindow: false,
            showManifestWindow: false,
            streamName: '',
            setFilter: '',
            statusFilter: '',
            initiatorFilter: '',
            formatFilter: '',
            showTopLevel: true,
            refreshRate: refreshRate,
            tempRefreshRate: 0,
            sharedManifest: false,
            streamType: '',
            masterFile: false,
            treeOrder: true,
            audioEnabled: false,
            videoEnabled: false,
            pixelEnabled: false
        });

        // process shortcuts in the columns sets into fields ready for React Table
        Renderers.ReactTable(this.columnSets);

        this.onDataUpdated = this.onDataUpdated.bind(this);
        this.openTextTracksWindowPortal = this.openTextTracksWindowPortal.bind(this);
        this.closeTextTracksWindowPortal = this.closeTextTracksWindowPortal.bind(this);
        this.openMIMEHeaderWindowPortal = this.openMIMEHeaderWindowPortal.bind(this);
        this.closeMIMEHeaderWindowPortal = this.closeMIMEHeaderWindowPortal.bind(this);
        this.openMediaFileWindowPortal = this.openMediaFileWindowPortal.bind(this);
        this.closeMediaFileWindowPortal = this.closeMediaFileWindowPortal.bind(this);
        this.openManifestWindowPortal = this.openManifestWindowPortal.bind(this);
        this.closeManifestWindowPortal = this.closeManifestWindowPortal.bind(this);
        this.setRefreshInterval = this.setRefreshInterval.bind(this);
        this.setRefreshIntervalInCache = this.setRefreshIntervalInCache.bind(this);

        if (window.localStorage && (host = window.localStorage.getItem('host'))) {
            // tslint:disable-next-line:no-console
            console.log('determined host via local storage: ', host);
        } else
            host = window.location.host;

        imgurl = 'http://' + host;
        if (this.isSecureSite()) {
            imgurl = 'https://' + host;
        }

        this.setState({
            host,
            imgurl
        });
    }

    componentDidMount() {
        window.addEventListener('beforeunload', () => {
            this.closeMIMEHeaderWindowPortal();
            this.closeMediaFileWindowPortal();
            this.closeManifestWindowPortal();
        });
    }

    setRefreshInterval(interval?: number) {
        this.setState({ refreshRate: interval });
    }

    setRefreshIntervalInCache(interval?: number) {
        this.setState({ refreshRate: interval });
        if (!(interval === undefined)) {
            window.localStorage.setItem('refreshRate', JSON.stringify(interval));
        }
    }
    openTextTracksWindowPortal() {
        this.setState(state => ({
            ...state,
            showTextTracksWindow: true
        }));
    }

    closeTextTracksWindowPortal() {
        this.setState({ showTextTracksWindow: false });
    }

    openMIMEHeaderWindowPortal() {
        this.setState(state => ({
            ...state,
            showMIMEHeaderWindow: true
        }));
    }

    closeMIMEHeaderWindowPortal() {
        this.setState({ showMIMEHeaderWindow: false });
    }

    openMediaFileWindowPortal() {
        this.setState(state => ({
            ...state,
            showMediaFileWindow: true
        }));
    }

    closeMediaFileWindowPortal() {
        this.setState({ showMediaFileWindow: false });
    }

    openManifestWindowPortal() {
        this.setState(state => ({
            ...state,
            showManifestWindow: true
        }));
    }

    closeManifestWindowPortal() {
        this.setState({ showManifestWindow: false });
    }

    openTextTracksWindow(props: any) {
        // get access to props from showMenuOptions. Need it to get streamId
        // set state and open mime header window here
        this.setState({
          streamIdForPopup: props.original.status.streamid,
          streamNameForPopup: props.original.status.name,
          url: props.original.status.url
        });
        this.openTextTracksWindowPortal();
    }

    openMIMEHeaderWindow(props: any) {
        // get access to props from showMenuOptions. Need it to get streamId
        // set state and open mime header window here
        this.setState({
            streamIdForPopup: props.original.status.streamid,
            streamNameForPopup: props.original.status.name,
            url: props.original.status.url
        });
        this.openMIMEHeaderWindowPortal();
    }

    openMediaFileWindow(props: any) {
        this.setState({
            streamIdForPopup: props.original.status.streamid,
            streamNameForPopup: props.original.status.name,
            url: props.original.status.url,
            mode: props.original.status.monitorMode,
            audioEnabled: props.original.statistics.qoe.audioEnabled,
            videoEnabled: props.original.statistics.qoe.videoEnabled,
            pixelEnabled: props.original.statistics.qoe.pixelEnabled
        });
        this.openMediaFileWindowPortal();
    }

    openManifestWindow(props: any) {
        this.setState({
            streamIdForPopup: props.original.status.streamid,
            streamNameForPopup: props.original.status.name,
            url: props.original.status.url,
            sharedManifest: props.original.status.sharedManifest,
            streamType: props.original.status.streamType,
            masterFile: props.original.status.master
        });
        this.openManifestWindowPortal();
    }

    tooltipRenderer(): React.ReactNode {
        return <ReactTooltip effect="float" place="top" html={true} delayShow={500} offset={{top: 10, left: 10}} className="tool-tip-override-general"/>;
    }

    tooltipHeading(heading: any): React.ReactNode {
        return <ReactTooltip effect="float" place="top" html={true} delayShow={500} offset={{top: 10, left: 10}} className="tool-tip-override-general">{heading}</ReactTooltip>;
    }

    buttonRenderer(props: any): React.ReactNode {
        return (
            <div className="cellIcons">
                <Dropdown item icon="bars" >
                    <Dropdown.Menu>
                        <Dropdown.Item onClick={() => this.openManifestWindow(props)}>Manifests</Dropdown.Item>
                        {(!props.original.status.master) && <Dropdown.Item onClick={() => this.openMediaFileWindow(props)}>Media Files</Dropdown.Item>}
                        {(props.original.status.master && props.original.status.sharedManifest && props.original.status.streamType === 'DASH') && <Dropdown.Item onClick={() => this.openMediaFileWindow(props)}>Media Files</Dropdown.Item>}
                        {(!props.original.status.master && props.original.status.media && props.original.status.media.includes('text')) && <Dropdown.Item onClick={() => this.openTextTracksWindow(props)}>Text Tracks</Dropdown.Item>}
                        <Dropdown.Item onClick={() => this.openMIMEHeaderWindow(props)}>MIME Headers</Dropdown.Item>
                        <Dropdown.Divider />
                        <Dropdown.Item as={Link} to={{ pathname: '/logs/transaction', state: { streamid: props.original.status.streamid, name: props.original.status.name} }}>Transaction
                            Log</Dropdown.Item>
                        <Dropdown.Item as={Link} to={{ pathname: '/logs/alarm', state: { name: props.original.status.name} }}>Alarm
                            Log</Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </div>
        );
    }
    getRowClassName(index: number) {
        if (index < 0) {
            return 'headerRow';
        } else {
            return index % 2 === 0 ? 'evenRow' : 'oddRow';
        }
    }
    
    thumbnailRenderer(props: any): React.ReactNode {
        let currentDate = new Date().getTime();
        let thumbnail: string; let image: string;
        let divStyle;

        thumbnail = this.state.imgurl + props.original.statistics.qoe.thumbnail + '?$' + currentDate;
        image = '<img alt="" src=' + thumbnail + '/>';
        divStyle = {
            lineHeight: '2em',
            padding: '0px',
            height: '2.5em',
            width: '60px'
        };
        return (
            <div className="cell-thumbnail" data-tip={image} style={divStyle} data-class="tool-tip-override" data-place="right">
                <img alt="" src={thumbnail} />
            </div>
        );
    }

    statusRenderer(props: any): React.ReactNode {
        let clsName = 'status-chicklet ';

        const fmstate = props.original.statistics           // check validity of each field
            && props.original.statistics.general
            && props.original.statistics.general.alarms
            && props.original.statistics.general.alarms.fmstate;

        switch (fmstate) {
            case 0: clsName += 'iq-td-status-clear'; break;       // Good        = Green
            case 1: clsName += 'iq-td-status-critical'; break;    // Error       = Red
            case 2: clsName += 'iq-td-alarm-minr'; break;         // History     = Yellow
            case 4: clsName += 'iq-td-alarm-major'; break;        // Unavailable = Orange
            case 6: clsName += 'iq-td-status-outage'; break;      // Outage      = Black
            default: clsName += 'iq-td-status-unknown'; break;    // Unknown     = Clear
        }

        let tooltip = props.original.status.name + ' : ' + ((props.original.status.manifestIP) ? props.original.status.manifestIP : '0.0.0.0');

        return (
            <div data-tip={tooltip}>
                {this.tooltipRenderer()}
                <span className={clsName}/>
            </div>
        );
    }

    assetNameRenderer(props: any): React.ReactNode  {
        let clsName = 'td-colored-cell ';
        const icon = 'unlock';
        const tooltipText = 'Stream decryption enabled';
        const showIcon = (props.original.statistics.qoe.decryptActive === true);

        // SAN-3181: Check for stream type of 'HLS Component'.
        let master = props.original.status ? (props.original.status.master || props.original.status.streamType.endsWith('Component')) : false;
        let subRepMaster = props.original.status ? props.original.status.subRepId === props.original.status.streamId : false;
        let subRep = props.original.status ? props.original.status.subRep : false;

        // determine how to display data for sub-representations.
        if (master && !subRepMaster && !subRep) {
            clsName += 'assetName';
        } else if (!master && subRepMaster && subRep) {
            clsName = 'variantName';
        } else if (!master && !subRepMaster && subRep) {
            clsName += 'variantName subRepName';
        } else {
            clsName += 'variantName';
        }

        return (
            <div className={clsName} title={props.original.status.name}>
                {props.original.status.name}
                {showIcon ?
                    <span data-tip={tooltipText}>
                        {this.tooltipRenderer()}
                        <FontAwesome size="lg" className={'census-cell-unlock-icon'} name={icon}/></span>
                    : ''
                }
            </div>
        );
    }

    derivedVariantRenderer(props: any, bitMap: any, index: number): React.ReactNode {
        let clsName = '';
        let value = Renderers.secToMsec2(props.value);

        if (props.original.statistics && props.original.statistics.general) {
            clsName = this.getAlarmHighlight(props, bitMap, index);
        }

        return (
            <div className={clsName}>
                {value}</div>
        );
    }

    initiatorRenderer(props: any) {
        let icon = '';
        /*Scheduler - started via Daily Scheduler routine as configured in Monitor Configuration | Scheduler
        * Scanner - started via configuration in Monitor Configuration | Scanner
        * User - initiated by user in UI
        * Event Scheduler - started via API using event API
        * API - started via API (see client field)
        * Auto - started on service startup as per configuration */
        if (props === 'Auto') {
            icon = 'refresh';
        }
        if (props === 'User') {
            icon = 'user';
        }
        if (props === 'Scheduler') {
            icon = 'clock-o';
        }
        if (props === 'Scanner') {
            icon = 'barcode';
        }
        if (props === 'API') {
            icon = 'cogs';
        }
        if (props === 'Event Scheduler') {
            icon = 'calendar';
        }
        return (
            <div data-tip={props}>
                {this.tooltipRenderer()}
                {<FontAwesome name={icon}/>}
            </div>
        );
    }

    headerRenderer(header: any, headerText: string) {

        return (
            <div>
                <span data-tip={headerText} data-for="headerTip">
                    {header}
                </span>
                <ReactTooltip id="headerTip" place="top" effect="solid" html={true} />
            </div>
        );
    }

    getAvailabilityPercentage(monitoredSecs: number, errorSecs: number): number {
        if ( typeof(monitoredSecs) === 'number' && typeof(errorSecs) === 'number') {
            const val = ((monitoredSecs - errorSecs) * 100 / monitoredSecs);
            return ((isNaN(val))
                ? -1
                : val);
        } else {
            return -1;
        }
    }

    commaRenderer(props: any): React.ReactNode {
        let value = Renderers.commaSeparated(props.value);
        if (props.original.status.master)
            value =  '-';
        return (
            <div>{value}</div>
        );
    }
    bytesToKbRenderer(props: any): React.ReactNode {
        let value = Renderers.bytesToKB(props.value);
        if (props.original.status.master)
            value =  '-';
        return (
            <div>{value}</div>
        );
    }

    renderBitRate(props: any): React.ReactNode {
        let value = Renderers.bytesToKB(props.value);
        if (props.original.status.monitorMode === 'Header Only' || props.original.status.master)
            value =  '-';
        return (
            <div>{value}</div>
        );
    }

    outageRenderer(props: any, buffer: boolean): React.ReactNode {
      let clsName = 'iq-td-status-clear';

      if ( props.original.statistics.general && props.original.statistics.general.outage.state === 1) {
        clsName = 'iq-td-status-outage';
      }

      const inlineStyle = {
          paddingRight: '10px'
      };

      return (
        <div className={clsName}>
            {<span style={buffer ? inlineStyle : {}}> {props.value.count} / {props.value.seconds} </span>}
        </div>
      );
    }

    checkNotMaster(props: any, bitMap: any, index: number): React.ReactNode {
        let clsName = '';
        let value = props.value;

        if (!props.original.status.master) {
            value = '-'; clsName = '';
        } else {
            if (props.original.statistics && props.original.statistics.general) {
                clsName = this.getAlarmHighlight(props, bitMap, index);
            }
        }

        if (value === undefined)
            value = '0';

        return(
            <div className={clsName}>
                {value}
            </div>
        );
    }
    commonAlarm0Renderer(props: any, bitMap: any, index: number): React.ReactNode {
        let clsName = '';
        let value = props.value;

        if (props.original.statistics && props.original.statistics.general) {
            clsName = this.getAlarmHighlight(props, bitMap, index);
        }

        if (value === undefined)
            value = '0';

        return(
            <div className={clsName}>
                {value}
            </div>
        );
    }

    checkNA(props: any, bitMap: any, index: number, buffer: boolean): React.ReactNode  {

        let clsName = '';
        let value = props.value;

        if (props.original.statistics && props.original.statistics.general) {
            clsName = this.getAlarmHighlight(props, bitMap, index);
        }

        if (props.original.status.master)
            value = '-';
        else if (props.value === 0)
            value = '-';

        const inlineStyle = {
            paddingRight: '10px'
        };

        return(
            <div className={clsName}>
                {buffer ? <span style={inlineStyle}> {value} </span> : value}
            </div>
        );
    }

    checkMediaType(props: any, bitMap: any, index: number, buffer: boolean): React.ReactNode {
        let clsName = '';
        let value = props.value;

        if (props.original.statistics && props.original.statistics.general) {
            clsName = this.getAlarmHighlight(props, bitMap, index);
        }

        if (props.original.status.master || (!(props.original.status.media && props.original.status.media.includes('text')))) {
            value =  '-'; clsName = '';
        }

        const inlineStyle = {
            paddingRight: '10px'
        };

        return(
            <div className={clsName}>
                {buffer ? <span style={inlineStyle}> {value} </span> : value}
            </div>
        );
    }

    checkMaster(props: any, bitMap: any, index: number): React.ReactNode  {
        let clsName = '';
        let value;

        if (props.column.id === 'derivedVariantStartTime') {
            value = Renderers.secToMsec2(props.value);
        } else {
            value = props.value;
        }

        if (props.original.statistics && props.original.statistics.general) {
            clsName = this.getAlarmHighlight(props, bitMap, index);
        }

        if (props.column.id === 'derivedVariantStartTimeExceeded' && props.original.status.monitorMode === 'Header Only') {
            value = '-'; clsName = '';
        }

        if (props.original.status.master) {
            value = '-'; clsName = '';
        }

        const inlineStyle = {
            paddingRight: '10px'
        };

        return(
            <div className={clsName}>
                {props.column.id === 'formatMismatchError' ? <span style={inlineStyle}> {value} </span> : value}
            </div>
        );
    }
    checkVariant(props: any, bitMap: any, index: number, field: string): React.ReactNode  {
        let value = '-';
        let clsName = '';

        if (props.original.status.master) {
            if (props.original.statistics && props.original.statistics.general) {
                clsName = this.getAlarmHighlight(props, bitMap, index);
            }
        }

        if (props.original.status.master) {
            if (field === 'missing') {
                value =  props.original.statistics.files && props.original.statistics.files.manifest ? props.original.statistics.files.manifest.varReqCnt : '-';
            } else if (field === 'total') {
                value =  props.original.statistics.files && props.original.statistics.files.manifest ? props.original.statistics.files.manifest.varReqErr : '-';
            }
        }

        return(
            <div className={clsName}>
                {value}
            </div>
        );
    }
    checkVariantOrig(props: any, field: string): React.ReactNode  {
        let value = '-';

        if (props.original.status.master) {
            if (field === 'missing') {
                value =  props.original.statistics.files && props.original.statistics.files.manifest ? props.original.statistics.files.manifest.varReqCnt : '-';
            } else if (field === 'total') {
                value =  props.original.statistics.files && props.original.statistics.files.manifest ? props.original.statistics.files.manifest.varReqErr : '-';
            }
        }
        return(
            <div>{value}</div>
        );
    }
    commaSeparated(value: any): React.ReactNode {
        let parts = value.toString().split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return <span  className="right-aligned">{parts.join('.')}</span>;
    }
    httpCodesRenderer(value: any) {
        if (value === null || value === undefined) {
            return (
                <div>
                    <div className="http totals">
                        <div className="http2xxBox-empty">-</div>
                        <div className="http3xxBox-empty">-</div>
                        <div className="http4xxBox-empty">-</div>
                        <div className="http5xxBox-empty">-</div>
                        <div className="outline" data-tip="close">-</div>
                        <div className="outline" data-tip="socket and other">-</div>
                    </div>
                </div>);
        } else {
            return (
                <div
                    className="http totals"
                    title="2xx, 3xx, 4xx, 5xx http error counts, close errors and socket errors"
                >
                    <div className={(value.hss2xx === 0 || value.hss2xx === undefined) ? 'http2xxBox-empty' : 'http2xxBox'} title="2xx">{(value.hss2xx === 0 || value.hss2xx === undefined) ? '-' : this.commaSeparated(value.hss2xx)}</div>
                    {/* tslint:disable-next-line:max-line-length */}
                    <div className={(value.hsr3xxTotal === 0 || value.hsr3xxTotal === undefined) ? 'http3xxBox-empty' : 'http3xxBox'} title="3xx">{(value.hsr3xxTotal === 0 || value.hsr3xxTotal === undefined) ? '-' : this.commaSeparated(value.hsr3xxTotal)}</div>
                    {/* tslint:disable-next-line:max-line-length */}
                    <div className={(value.hsce4xxTotal === 0 || value.hsce4xxTotal === undefined) ? 'http4xxBox-empty' : 'http4xxBox'} title="4xx">{(value.hsce4xxTotal === 0 || value.hsce4xxTotal === undefined) ? '-' : this.commaSeparated(value.hsce4xxTotal)}</div>
                    {/* tslint:disable-next-line:max-line-length */}
                    <div className={(value.hsse5xxTotal === 0 || value.hsse5xxTotal === undefined) ? 'http5xxBox-empty' : 'http5xxBox'} title="5xx">{(value.hsse5xxTotal === 0 || value.hsse5xxTotal === undefined) ? '-' : this.commaSeparated(value.hsse5xxTotal)}</div>
                    <div className="http-close outline" title="close">{(value.close === 0 || value.close === undefined) ? '-' : this.commaSeparated(value.close)}</div>
                    <div className="http-other outline" title="socket and other">{(value.socketErrors === 0 || value.socketErrors === undefined) ? '-' : this.commaSeparated(value.socketErrors)}</div>
                </div>
            );
        }
    }
    checkMasterRenderer(props: any, buffer: boolean) {
        let value = props.value;

        if (props.column.id === 'bufferGearChangePercent') {
            value = props.value.toFixed(2);
        }
        if (props.original.status.master)
            value = '-';

        const inlineStyle = {
            paddingRight: '10px'
        };

        return(
            <div>
                {buffer ? <span style={inlineStyle}> {value} </span> : value}
            </div>
        );
    }
    checkNARenderer(props: any) {
        if (props.original.status.master)
            return '-';
        else if (props.value === 0)
            return '-';
        else
            return props.value;
    }
    serverChangeRenderer(props: any) {
        if (props.original.status.master) {
            return (props.original.statistics.connection && props.original.statistics.connection.manifest ? props.original.statistics.connection.manifest.IPChanges : '');
        } else {
            return (props.original.statistics.connection && props.original.statistics.connection.manifest ? props.original.statistics.connection.manifest.IPChanges + ' / ' + props.original.statistics.connection.media.IPChanges : '');

        }
    }
    commonTimeRenderer(props: any, bitMap: any, index: number): React.ReactNode {
        let clsName = '';

        if (props.original.statistics && props.original.statistics.general) {
            clsName = this.getAlarmHighlight(props, bitMap, index);
        }

        return(
            <div className={clsName}>
                {(props.value / 1000).toFixed(3)}
            </div>
        );
    }

    commonMasterTimeRenderer(props: any, bitMap: any, index: number): React.ReactNode {
        let clsName = '';

        if (props.original.status.master)
            return '-';
        else if (props.original.statistics && props.original.statistics.general) {
            clsName = this.getAlarmHighlight(props, bitMap, index);
        }

        return(
            <div className={clsName}>
                {props.value}
            </div>
        );
    }

    getAlarmHighlight(props: any, bitMap: any, index: number) {
        let clsName: string;
        let activeAlarmField = props.original.statistics.general.alarms.active[index];
        let monitoredAlarmField = props.original.statistics.general.alarms.monitored[index];
        let historyAlarmField = props.original.statistics.general.alarms.history[index];

        // tslint:disable-next-line:no-bitwise
        if ((monitoredAlarmField & bitMap) !== 0) {
            // tslint:disable-next-line:no-bitwise
            if ((activeAlarmField & bitMap) !== 0) {
                clsName = 'iq-td-alarm-critical';
                // tslint:disable-next-line:no-bitwise
            } else if ((historyAlarmField & bitMap) !== 0) {
                clsName = 'iq-td-alarm-minr';
            } else {
                clsName = 'iq-td-status-clear';
            }
        } else {
            // tslint:disable-next-line:no-bitwise
            if ((historyAlarmField & bitMap) !== 0) {
                clsName = 'iq-td-alarm-minr';
            } else {
                clsName = '';
            }
        }

        if (clsName === '') {
            if (props.column.id === 'loudness') {
                bitMap = 0x00400000; index = 1;
                activeAlarmField = props.original.statistics.general.alarms.active[index];
                monitoredAlarmField = props.original.statistics.general.alarms.monitored[index];
                historyAlarmField = props.original.statistics.general.alarms.history[index];

                // tslint:disable-next-line:no-bitwise
                if ((monitoredAlarmField & bitMap) !== 0) {
                    // tslint:disable-next-line:no-bitwise
                    if ((activeAlarmField & bitMap) !== 0) {
                        clsName = 'iq-td-alarm-critical';
                        // tslint:disable-next-line:no-bitwise
                    } else if ((historyAlarmField & bitMap) !== 0) {
                        clsName = 'iq-td-alarm-minr';
                    } else {
                        clsName = 'iq-td-status-clear';
                    }
                } else {
                    // tslint:disable-next-line:no-bitwise
                    if ((historyAlarmField & bitMap) !== 0) {
                        clsName = 'iq-td-alarm-minr';
                    } else {
                        clsName = '';
                    }
                }
            }
        }
        return clsName;
    }

    checkVideoProps(props: any): React.ReactNode {
        let value = props.value;

        if (props.original.statistics.qoe.videoEnabled === false) {
            value = '-';
        } else if (props.original.statistics.qoe.videoActive === false || props.original.statistics.qoe.videoAvail === false) {
            value = '-';
        } else if (props.original.statistics.qoe.mos.video.samples === 0) {
            value = '-';
        }

        return (
            <div>{value}</div>
        );
    }

    checkQoEMedia(props: any, bitMap: any, index: number): React.ReactNode {
        let clsName = '';
        let value = props.value;

        if (props.original.statistics && props.original.statistics.general) {
            clsName = this.getAlarmHighlight(props, bitMap, index);
        }

        if (props.original.statistics && props.original.statistics.qoe) {
            if (props.column.id === 'videoMos') {
                if (props.original.statistics.qoe.videoEnabled === false) {
                    value = '-'; clsName = '';
                } else if (props.original.statistics.qoe.videoActive === false || props.original.statistics.qoe.videoAvail === false) {
                    value = '-'; clsName = '';
                } else if (props.original.statistics.qoe.mos.video.samples === 0) {
                    value = '-'; clsName = '';
                } else {
                    if (props.value === 0) {
                        value = props.value;
                    } else {
                        value = props.value.toFixed(2);
                    }
                }
            } else if (props.column.id === 'gopMos') {
                if (props.original.statistics.qoe.videoEnabled === false) {
                    value = '-'; clsName = '';
                } else if (props.original.statistics.qoe.videoActive === false || props.original.statistics.qoe.videoAvail === false) {
                    value = '-'; clsName = '';
                } else if (props.original.statistics.qoe.mos.gop.samples === 0) {
                    value = '-'; clsName = '';
                } else {
                    if (props.value === 0) {
                        value = props.value;
                    } else {
                        value = props.value.toFixed(2);
                    }
                }
            } else if (props.column.id === 'stillFrame') {
                if (props.original.statistics.qoe.videoEnabled === false) {
                    value = '-'; clsName = '';
                } else if (props.original.statistics.qoe.videoActive === false || props.original.statistics.qoe.videoAvail === false) {
                    value = '-'; clsName = '';
                } else if (props.original.statistics.qoe.gop.stillness.samples === 0) {
                    value = '-'; clsName = '';
                } else {
                    let frames = props.original.statistics.qoe.gop.stillFrame;
                    value = props.value + '% / ' + frames;
                }
            } else if (props.column.id === 'blackScreen') {
                if (props.original.statistics.qoe.videoEnabled === false) {
                    value = '-'; clsName = '';
                } else if (props.original.statistics.qoe.videoActive === false || props.original.statistics.qoe.videoAvail === false) {
                    value = '-'; clsName = '';
                } else if (props.original.statistics.qoe.gop.blackness.samples === 0) {
                    value = '-'; clsName = '';
                } else {
                    let frames = props.original.statistics.qoe.gop.blackFrame;
                    value = props.value + '% / ' + frames;
                }
            } else if (props.column.id === 'audioMos') {
                if (props.original.statistics.qoe.audioEnabled === false) {
                    value = '-'; clsName = '';
                } else if (props.original.statistics.qoe.audioActive === false || props.original.statistics.qoe.audioAvail === false) {
                    value = '-'; clsName = '';
                } else if (props.original.statistics.qoe.mos.audio.samples === 0) {
                    value = '-'; clsName = '';
                } else {
                    if (props.value === 0) {
                        value = props.value;
                    } else {
                        value = props.value.toFixed(2);
                    }
                }
            } else if (props.column.id === 'loudness') {
                if (props.original.statistics.qoe.audioEnabled === false) {
                    value = '-'; clsName = '';
                } else if (props.original.statistics.qoe.audioActive === false || props.original.statistics.qoe.audioAvail === false) {
                    value = '-'; clsName = '';
                } else if (props.original.statistics.qoe.audio.loudness.samples === 0) {
                    value = '-'; clsName = '';
                } else {
                    if (props.value === undefined) {
                        value = 0;
                    } else {
                        if (props.value === 0) {
                            value = props.value;
                        } else {
                            value = props.value.toFixed(2);
                        }
                    }
                }
            } else if (props.column.id === 'silence') {
                if (props.original.statistics.qoe.audioEnabled === false) {
                    value = '-'; clsName = '';
                } else if (props.original.statistics.qoe.audioActive === false || props.original.statistics.qoe.audioAvail === false) {
                    value = '-'; clsName = '';
                } else {
                    value = props.value;
                }
            } else if (props.column.id === 'dialnorm') {
                if (props.original.statistics.qoe.audioEnabled === false) {
                    value = '-'; clsName = '';
                } else if (props.original.statistics.qoe.audioActive === false || props.original.statistics.qoe.audioAvail === false) {
                    value = '-'; clsName = '';
                } else if (props.original.statistics.qoe.audio.dialnorm.samples === 0) {
                    value = '-'; clsName = '';
                } else {
                    value = props.value;
                }
            } else if (props.column.id === 'dialnormDeviation') {
                if (props.original.statistics.qoe.audioEnabled === false) {
                    value = '-'; clsName = '';
                } else if (props.original.statistics.qoe.audioActive === false || props.original.statistics.qoe.audioAvail === false) {
                    value = '-'; clsName = '';
                } else if (props.original.statistics.qoe.audio.loudnessDnDev.samples === 0) {
                    value = '-'; clsName = '';
                } else {
                    value = props.value;
                }
            } else if (props.column.id === 'pixelBlockArtifact') {
                if (props.original.statistics.qoe.pixelEnabled === false) {
                    value = '-'; clsName = '';
                } else if (props.original.statistics.qoe.pixelActive === false || props.original.statistics.qoe.pixelAvail === false) {
                    value = '-'; clsName = '';
                } else if (props.original.statistics.qoe.pixel.pixelGop.samples === 0) {
                    value = '-'; clsName = '';
                } else {
                    value = props.value;
                }
            }
        } else {
            value = '-'; clsName = '';
        }

        const inlineStyle = {
            paddingRight: '10px'
        };

        if (props.column.id === 'silence' && clsName !== 'iq-td-alarm-disabled') {
            return(
                <div className={clsName}>
                    <span style={inlineStyle}> {value} </span>
                </div>
            );
        } else {
            if (props.column.id === 'dialnormDeviation' && clsName === 'iq-td-alarm-disabled') {
                return(
                    <div className={clsName} data-tip="Unsupported Codec">
                        {this.tooltipRenderer()}
                        <span style={inlineStyle}> - </span>
                    </div>
                );
            } else {
                if (clsName === 'iq-td-alarm-disabled') {
                    return (
                        <div className={clsName} data-tip="Unsupported Codec">
                            {this.tooltipRenderer()}
                            -
                        </div>
                    );
                } else {
                    return (
                        <div className={clsName}>
                            {value}
                        </div>
                    );
                }
            }
        }
    }

    commonAlarmRenderer(props: any, bitMap: any, index: number, buffer: boolean) {
        let clsName = '';
        let value = props.value;

        if (props.original.statistics && props.original.statistics.general) {
            clsName = this.getAlarmHighlight(props, bitMap, index);
        }

        const inlineStyle = {
            paddingRight: '10px'
        };

        return(
            <div className={clsName}>
                {buffer ? <span style={inlineStyle}> {value} </span> : value}
            </div>
        );
    }

    enabled(view: string): boolean {
        return _.includes(this.state.columns, view);
    }

    // handleFilter() {
    //     let prevRefreshRate = this.state.refreshRate;
    //     this.setRefreshInterval(1000);
    //     setTimeout(() => this.setState({refreshRate: prevRefreshRate}), 2000);
    // }
    handleReset() {
        let prevRefreshRate = this.state.refreshRate;
        this.setRefreshInterval(1000);
        setTimeout(() => this.setState({refreshRate: prevRefreshRate}), 2000);

        this.setState({
            streamName: '',
            setFilter: '',
            statusFilter: '',
            formatFilter: '',
            initiatorFilter: ''
        });
    }

    isVeristreamVisible() {
        // SAN-2696 only update when veristream tab is showing
        const {columns} = this.state;
        return (columns && columns.findIndex((v) => v === 'Streaming Performance / Delivery') >= 0);
    }

    onDataUpdated() {
        // initiate a request to update the veristream chicklets
        if (this.isVeristreamVisible()) { // SAN-2696 only update when veristream tab is showing
            let url = 'http://default/api/stream/veristream';
            axios.post(url, {
                streams: 'census'
            })
                .then((response: AxiosResponse) => {
                    if (response.data !== undefined && Array.isArray(response.data.streams)) {
                        let veristream = {};
                        response.data.streams.forEach((v: any) => {
                            // parse each stream's veristream collection into a dictionary (id => [vs-values])
                            if (v.streamid !== undefined && Array.isArray(v.history))
                                veristream[v.streamid] = v.history;
                        });
                        this.setState({veristream});  // set veristream collection in state
                    }
                })
                .catch((error: AxiosRequestConfig) => {
                    // tslint:disable-next-line:no-console
                    console.trace('failed to get veristream data, error: ', error);
                });
        }
    }

    updateVeristreamChicklets() {
        // initiate a request to update the veristream chicklets
        let url = 'http://default/api/stream/veristream';
        axios.post(url, {
            streams: 'census'
        })
            .then((response: AxiosResponse) => {
                if (response.data !== undefined && Array.isArray(response.data.streams)) {
                    let veristream = {};
                    response.data.streams.forEach((v: any) => {
                        // parse each stream's veristream collection into a dictionary (id => [vs-values])
                        if (v.streamid !== undefined && Array.isArray(v.history))
                            veristream[v.streamid] = v.history;
                    });
                    this.setState({veristream});  // set veristream collection in state
                }
            })
            .catch((error: AxiosRequestConfig) => {
                // tslint:disable-next-line:no-console
                console.trace('failed to get veristream data, error: ', error);
            });
    }

    computeFilters() {
        let addSetMembership = false;
        let params: {};
        let stream: string;

        if ((this.state.streamName.startsWith('\'') && this.state.streamName.endsWith('\'')) || (this.state.streamName.startsWith('\"') && this.state.streamName.endsWith('\"'))) {
            stream = 'name and census';
        } else {
            // Adding name% to support partial string match
            stream = 'name% and census';
        }

        if (this.state.setFilter !== undefined && this.state.setFilter !== '') {
            stream += ' and setMembership';
            addSetMembership = true;
        }

        if (this.state.statusFilter !== '') {
            if ( this.state.statusFilter === 'alarm') {
                stream += ' and alarmed';
            } else if ( this.state.statusFilter === 'outage') {
                stream += ' and outage';
            } else if ( this.state.statusFilter === 'history') {
                stream += ' and history';
            } else if ( this.state.statusFilter === 'good') {
                stream += ' and (!alarmed and !errored and !outage)';
            }
        }
        if (this.state.formatFilter !== '') {
            if ( this.state.formatFilter === 'dash') {
                stream += ' and dash';
            } else if ( this.state.formatFilter === 'hls') {
                stream += ' and hls';
            } else if ( this.state.formatFilter === 'hss') {
                stream += ' and hss';
            } else if ( this.state.formatFilter === 'hds') {
                stream += ' and hds';
            }
        }
        if (this.state.initiatorFilter !== '') {
            if ( this.state.initiatorFilter === 'manual') {
                stream += ' and manual';
            } else if ( this.state.initiatorFilter === 'scan') {
                stream += ' and scanning ';
            } else if ( this.state.initiatorFilter === 'schedule') {
                stream += ' and (scheduling or eventScheduling)';
            }
        }
        if (addSetMembership) {
            params = {
                streams: stream,
                // tslint:disable-next-line:max-line-length
                name: this.state.streamName.length ? ((this.state.streamName.startsWith('\'') && this.state.streamName.endsWith('\'')) || (this.state.streamName.startsWith('\"') && this.state.streamName.endsWith('\"'))) ? this.state.streamName.slice(1, this.state.streamName.length - 1) : this.state.streamName : this.state.streamName,
                setMembership: this.state.setFilter,
                namespace: 'api.surveyor.abr',
                timerange: 'current',
                metrics: [ 'session.status', 'session.statistics.cycle+fifteen']
            };
        } else {
            params = {
                streams: stream,
                // tslint:disable-next-line:max-line-length
                name: this.state.streamName.length ? ((this.state.streamName.startsWith('\'') && this.state.streamName.endsWith('\'')) || (this.state.streamName.startsWith('\"') && this.state.streamName.endsWith('\"'))) ? this.state.streamName.slice(1, this.state.streamName.length - 1) : this.state.streamName : this.state.streamName,
                namespace: 'api.surveyor.abr',
                timerange: 'current',
                metrics: [ 'session.status', 'session.statistics.cycle+fifteen']
            };
        }
        return params;
    }

    // groupSetRenderer(set: Array<string>) {
    //     if (set.findIndex((v) => v === 'Veristream') >= 0) {
    //         this.updateVeristreamChicklets();
    //     }
    //     window.localStorage.setItem('group-set', JSON.stringify({set}));
    //     this.setState( { columns: set });
    // }

    checkIfSectionColumnsAreChecked(colName: any, groupCols: any, allCols: any) {
        for (let index = 0; index < groupCols.length; index++) {
            for (const subkey in allCols[colName]) {
                if (groupCols[index].id === allCols[colName][subkey].id) {
                    if ( !allCols[colName][subkey].show) {
                        return false;
                    }
                }
            }
        }
        return true;
    }

    checkIfAllColumnsAreChecked(groupCols: any, allCols: any) {
        for (const section in groupCols) {
            if (!this.checkIfSectionColumnsAreChecked(groupCols[section].text, groupCols[section].columns, allCols)) {
                return false;
            }
        }
        return true;
    }

    handleCheckedColumn(data: any, colName: any, sumCol: any, allCols: any, index: any) {
        // let prevRefreshRate = this.state.refreshRate;
        // this.setRefreshInterval(1000);
        // setTimeout(() => this.setState({refreshRate: prevRefreshRate}), 2000);

        this.setState({tempRefreshRate: 1000});
        setTimeout(() => this.setState({tempRefreshRate: 0}), 2000);

        // allCols[colName][index] = {...allCols[colName][index], show: data.checked};

        for (const subkey in allCols[colName]) {
            if (sumCol.id === allCols[colName][subkey].id) {
                allCols[colName][subkey] = {...allCols[colName][subkey], show: data.checked};
            }
        }

        if (allCols[colName][index].id === 'veristreamDistribution' || allCols[colName][index].id === 'veristreamLast20Segments') {
            this.updateVeristreamChicklets();
        }

        window.localStorage.setItem('columns', JSON.stringify(allCols));

    }

    handleCheckedSectionColumn(data: any, colName: any, groupCols: any, allCols: any) {
        // let prevRefreshRate = this.state.refreshRate;
        // this.setRefreshInterval(1000);
        // setTimeout(() => this.setState({refreshRate: prevRefreshRate}), 2000);

        this.setState({tempRefreshRate: 1000});
        setTimeout(() => this.setState({tempRefreshRate: 0}), 2000);

        for (let index = 0; index < groupCols.length; index++) {
            this.handleCheckedColumn(data, colName, groupCols[index], allCols, index);
        }
    }

    handleUncheckSectionColumn(colName: any, groupCols: any, allCols: any, isQoE: any) {
        const sumCol = 'Summary';
        const abrCol = 'ABR Protocol';

        for (let index = 0; index < groupCols.length; index++) {
            allCols[colName][index] = {...allCols[colName][index], show: false};

        }
        if (isQoE) {
            for (const subkey in allCols[abrCol]) {
                if ( allCols[abrCol][subkey].id === 'iFrameMissing') {
                    allCols[abrCol][subkey] = {...allCols[abrCol][subkey], show: false};
                }
            }
            for (const subkey in allCols[sumCol]) {
                if ( allCols[sumCol][subkey].id === 'imageThumbnail') {
                    allCols[sumCol][subkey] = {...allCols[sumCol][subkey], show: false};
                }
            }
        }
    }

    handleAllColumnsChecked(data: any, groupCols: any, allCols: any) {
        // let prevRefreshRate = this.state.refreshRate;
        // this.setRefreshInterval(1000);
        // setTimeout(() => this.setState({refreshRate: prevRefreshRate}), 2000);

        this.setState({tempRefreshRate: 1000});
        setTimeout(() => this.setState({tempRefreshRate: 0}), 2000);

        for (let index = 0; index < groupCols.length; index++) {
            this.handleCheckedSectionColumn(data, groupCols[index].text, groupCols[index].columns, allCols);
        }
    }

    setDefaultColumns(allCols: any, initialLoad: any) {
        if (!initialLoad) {
            // let prevRefreshRate = this.state.refreshRate;
            // this.setRefreshInterval(1000);
            // setTimeout(() => this.setState({refreshRate: prevRefreshRate}), 2000);

            this.setState({tempRefreshRate: 1000});
            setTimeout(() => this.setState({tempRefreshRate: 0}), 2000);
        }

        for (const section in allCols) {
            if (allCols.hasOwnProperty(section)) {
                let showCol = (section === 'Summary' || section === '_' || section === ' ');
                for (const subkey in allCols[section]) {
                    if (allCols[section].hasOwnProperty(subkey)) {
                        allCols[section][subkey] = {...allCols[section][subkey], show: showCol};
                    }
                }
            }
        }
        window.localStorage.setItem('columns', JSON.stringify(allCols));
    }

    checkColumnsAgainstStoredColumns(columnSets: any, allCols: any) {
        let colStructuresMatch = true;

        // Checks the length of each section first
        for (const section in columnSets) {
            if (columnSets[section].length !== allCols[section].length) {
                colStructuresMatch = false;
            }
        }

        // If section lengths match, checks each column
        if (colStructuresMatch) {
            for (const section in columnSets) {
                if (columnSets.hasOwnProperty(section)) {
                    for (const subkey in columnSets[section]) {
                        if (columnSets[section][subkey].id !== allCols[section][subkey].id) {
                            colStructuresMatch = false;
                        }
                    }
                }
            }
        }
        return colStructuresMatch;
    }

    setInitialColumns(columnSets: any, allCols: any) {
        for (const section in columnSets) {
            if (columnSets.hasOwnProperty(section)) {
                for (const subkey in columnSets[section]) {
                    if (columnSets[section].hasOwnProperty(subkey)) {
                        if (columnSets[section][subkey].id === 'veristreamDistribution' || columnSets[section][subkey].id === 'veristreamLast20Segments') {
                            this.updateVeristreamChicklets();
                        }
                        const showCol = allCols[section][subkey].show;
                        columnSets[section][subkey] = {...columnSets[section][subkey], show: showCol};
                    }
                }
            }
        }
    }

    checkIfColumnSelected(colName: any, id: any, allCols: any) {
        for (const subkey in allCols[colName]) {
            if (allCols[colName][subkey].id === id) {
                return allCols[colName][subkey].show;
            }
        }
        return false;
    }

    render() {
        const statusOptions = [{ value: '', text: 'All'}, { value: 'good', text: 'Good' },
                              {  value: 'alarm', text: 'Alarmed' }, { value: 'outage', text: 'Outage' },
                              { value: 'history', text: 'History' }];

        const formatOptions = [{ value: '', text: 'All' }, { value: 'dash', text: 'DASH' },
                              { value: 'hls', text: 'HLS' }, { value: 'hss', text: 'HSS' },
                              { value: 'hds', text: 'HDS' }];

        const initiatorOptions = [{ value: '', text: 'All' }, { value: 'manual', text: 'Manual' },
                              { value: 'scan', text: 'Scan' }, { value: 'schedule', text: 'Schedule' }];

        // const groupOptionsQoEandDAI = [{key: 'Summary', value: 'Summary'}, {key: 'HTTP', value: 'HTTP Codes'}, {key: 'VeriStream', value: 'VeriStream'}, {key: 'MediaFiles', value: 'Media Files'},
        //     {key: 'Accessibility', value: 'Accessibility'}, {key: 'Performance', value: 'Performance'}, {key: 'ABR Protocol', value: 'ABR Protocol'}, {key: 'Quality of Experience', value: 'QoE'}, {key: 'Dynamic Ad Insertion', value: 'DAI'}];
        //
        // const groupOptionsQoEOnly = [{key: 'Summary', value: 'Summary'}, {key: 'HTTP', value: 'HTTP Codes'}, {key: 'VeriStream', value: 'VeriStream'}, {key: 'MediaFiles', value: 'Media Files'},
        //     {key: 'Accessibility', value: 'Accessibility'}, {key: 'Performance', value: 'Performance'}, {key: 'ABR Protocol', value: 'ABR Protocol'}, {key: 'Quality of Experience', value: 'QoE'}];
        //
        // const groupOptionsDAIOnly = [{key: 'Summary', value: 'Summary'}, {key: 'HTTP', value: 'HTTP Codes'}, {key: 'VeriStream', value: 'VeriStream'}, {key: 'MediaFiles', value: 'Media Files'},
        //     {key: 'Accessibility', value: 'Accessibility'}, {key: 'Performance', value: 'Performance'}, {key: 'ABR Protocol', value: 'ABR Protocol'}, {key: 'Dynamic Ad Insertion', value: 'DAI'}];
        //
        // const groupOptions = [{key: 'Summary', value: 'Summary'}, {key: 'HTTP', value: 'HTTP Codes'}, {key: 'VeriStream', value: 'VeriStream'}, {key: 'MediaFiles', value: 'Media Files'},
        //     {key: 'Accessibility', value: 'Accessibility'}, {key: 'Performance', value: 'Performance'}, {key: 'ABR Protocol', value: 'ABR Protocol'}];

        let groupOptions = [
            {key: 'Summary', text: 'Summary', columns: [
                    { id: 'initiator', text: 'Initiator'},
                    { id: 'streamType', text: 'Stream Type'}, { id: 'duration', text: 'Duration'},
                    { id: 'sessionAvailability', text: 'Session Availability'}, { id: '15MinuteAvailability', text: '15-Minute Availability'},
                    { id: 'streamOutage', text: 'Stream Outage'}
                ]
            }, {key: 'Accessibility', text: 'Accessibility', columns: [
                    { id: 'serverChanges', text: 'Server Changes'}, { id: 'dnsTime', text: 'DNS Time (ms)'},
                    { id: 'dnsTimeError15M', text: 'DNS  Time Error 15M'}, { id: 'dnsQueryFailure15M', text: 'DNS Query Failure 15M'},
                    { id: 'dnsQueryFailureWindow', text: 'DNS Query Failure Window'}, { id: 'tcpConnectionTime', text: 'TCP Connection Time (ms)'},
                    { id: 'tcpConnectionTime15M', text: 'TCP Connection Time 15M'}, { id: 'tcpConnectionFailure15M', text: 'TCP Connection Failure 15M'},
                    { id: 'tcpConnectionFailureWindow', text: 'TCP Connection Failure Window'}, { id: 'httpStatusCodes', text: 'HTTP Status Codes'},
                    { id: 'http4XxError15M', text: 'HTTP 4xx Error 15M'}, { id: 'http4XxErrorWindow', text: 'HTTP 4xx Error Window'},
                    { id: 'http5XxError15M', text: 'HTTP 5xx Error 15M'}, { id: 'http5XxErrorWindow', text: 'HTTP 5xx Error Window'},
                    { id: 'mimeHeader', text: 'MIME Header'}
                ]
            }, {key: 'ABR Protocol', text: 'ABR Protocol', columns: [
                    { id: 'playlistUnavailable', text: 'Playlist Unavailable'}, { id: 'playlistFileError', text: 'Playlist File Error'},
                    { id: 'playlistStall', text: 'Playlist Stall'}, { id: 'missingVariants', text: 'Missing Variants'}, { id: 'variantCountError', text: 'Variant Count Error'},
                    { id: 'variantRequiredError', text: 'Variant Required Error'}, { id: 'mediaFileUnavailable', text: 'Media File Unavailable'},
                    { id: 'mediaTimeDeviation', text: 'Media Time Deviation (sec)'}, { id: 'sequenceErrorContiguous', text: 'Sequence Error Contiguous'},
                    { id: 'sequenceError15M', text: 'Sequence Error 15M'}, { id: 'sequenceErrorTotal', text: 'Sequence Error Total'},
                    { id: 'mediaFileDurationError15M', text: 'Media File Duration Error 15M'}, { id: 'mediaFileBitrateError15M', text: 'Media File Bitrate Error 15M'},
                    { id: 'mediaFileTimeNotAligned', text: 'Media File Time Not Aligned'}, { id: 'audioNotPresent', text: 'Audio Not Present'},
                    { id: 'videoAudioSyncError', text: 'Video/Audio Sync Error'}, { id: 'decryptionError', text: 'Decryption Error'}
                ]
            }, {key: 'Streaming Performance / Delivery', text: 'Streaming Performance / Delivery', columns: [
                    { id: 'mediaFiles', text: 'Media Files'}, { id: 'currentSequence', text: 'Current Sequence'},
                    { id: 'totalKbytesDownloaded', text: 'Total Kbytes Downloaded'}, { id: 'mediaBitrate', text: 'Media Bitrate (kbps)'},
                    { id: 'downloadBitrate', text: 'Download Bitrate (kbps)'}, { id: 'videoStartFailure', text: 'Video Start Failure'},
                    { id: 'derivedVariantStartTime', text: 'Derived Variant Start Time (ms)'}, { id: 'derivedVariantStartTimeExceeded', text: 'Derived Variant Start Time Exceeded '},
                    { id: 'bufferGearChangePercent', text: 'Buffer / Gear Change %'}, { id: 'bufferGearChangeDuration', text: 'Buffer / Gear Change Duration (sec)'},
                    { id: 'bufferGearChanges15M', text: 'Buffer / Gear Changes 15M'}, { id: 'bufferGearChangesWindow', text: 'Buffer / Gear Changes Window'},
                    { id: 'downloadTimeExceededTotal', text: 'Download Time Exceeded Total'}, { id: 'downloadTimeExceededWindow', text: 'Download Time Exceeded Window'},
                    { id: 'veristreamDistribution', text: 'VeriStream Distribution'}, { id: 'veristreamLast20Segments', text: 'VeriStream (last 20 segments)'},
                    { id: 'veristreamErrorPeriod', text: 'VeriStream Error Period'}, { id: 'veristreamThresholdCross15M', text: 'VeriStream Threshold Cross 15M'},
                    { id: 'veristreamErrPeriodCurrent', text: 'VeriStream Err Period Current'}, { id: 'veristreamEdCurrent', text: 'VeriStream ED Current'}
                ]
            }, {key: 'Caption/Subtitle', text: 'Caption/Subtitle', columns: [
                    { id: 'captionCountErrorWindow', text: 'Caption Count Error Window'}, { id: 'textFormatErrorWindow', text: 'Text Format Error Window'},
                    { id: 'stallTextError', text: 'Stall Text Error'}
                ]
            }
            ];

        const qoeSection = {key: 'Media Quality', text: 'Media Quality', columns: [
                { id: 'videoMos', text: 'Video MOS'}, { id: 'gopMos', text: 'GOP MOS'},
                { id: 'blackScreen', text: 'Black Screen'}, { id: 'frameError', text: 'Frame Error'},
                { id: 'stillFrame', text: 'Still Frame'}, { id: 'pixelBlockArtifact', text: 'Pixel Block Artifact'},
                { id: 'audioMos', text: 'Audio MOS'}, { id: 'loudness', text: 'Loudness'}, { id: 'dialnorm', text: 'Dialnorm'},
                { id: 'dialnormDeviation', text: 'Dialnorm Deviation'}, { id: 'silence', text: 'Silence'},
            ]};

        const abrWithIframe = {key: 'ABR Protocol', text: 'ABR Protocol', columns: [
                { id: 'playlistUnavailable', text: 'Playlist Unavailable'}, { id: 'playlistFileError', text: 'Playlist File Error'},
                { id: 'playlistStall', text: 'Playlist Stall'}, { id: 'missingVariants', text: 'Missing Variants'}, { id: 'variantCountError', text: 'Variant Count Error'},
                { id: 'variantRequiredError', text: 'Variant Required Error'}, { id: 'mediaFileUnavailable', text: 'Media File Unavailable'},
                { id: 'mediaTimeDeviation', text: 'Media Time Deviation (sec)'}, { id: 'sequenceErrorContiguous', text: 'Sequence Error Contiguous'},
                { id: 'sequenceError15M', text: 'Sequence Error 15M'}, { id: 'sequenceErrorTotal', text: 'Sequence Error Total'},
                { id: 'mediaFileDurationError15M', text: 'Media File Duration Error 15M'}, { id: 'mediaFileBitrateError15M', text: 'Media File Bitrate Error 15M'},
                { id: 'mediaFileTimeNotAligned', text: 'Media File Time Not Aligned'}, { id: 'iFrameMissing', text: 'I-Frame Missing'},
                { id: 'audioNotPresent', text: 'Audio Not Present'}, { id: 'videoAudioSyncError', text: 'Video/Audio Sync Error'},
                { id: 'decryptionError', text: 'Decryption Error'}
            ]};

        const qoeSummary = {key: 'Summary', text: 'Summary', columns: [
            { id: 'imageThumbnail', text: 'Image Thumbnail'}, { id: 'initiator', text: 'Initiator'},
            { id: 'streamType', text: 'Stream Type'}, { id: 'duration', text: 'Duration'},
            { id: 'sessionAvailability', text: 'Session Availability'}, { id: '15MinuteAvailability', text: '15-Minute Availability'},
            { id: 'streamOutage', text: 'Stream Outage'}
        ]};

        const daiSection = {key: 'Dynamic Ad', text: 'Dynamic Ad', columns: [
                { id: 'spliceIntervalTime', text: 'Splice Interval Time'}, { id: 'spliceSequenceError', text: 'Splice Sequence Error'},
                { id: 'mediaDurationBeforeAd', text: 'Media Duration Before Ad'}, { id: 'playbackDurationUnderThreshold', text: 'Playback Duration Under Threshold'},
                { id: 'playbackDurationOverThreshold', text: 'Playback Duration Over Threshold'}, { id: 'formatMismatchError', text: 'Format Mismatch Error'}
            ]};

        let allColumns = this.columnSets;
        // const skipIframe = true;

        return (
            <OAuth.Context>
                {(oauth: OAuthClientStatus) => {
                    if (oauth.QoELicensePresent) {
                    // if(false) {
                        groupOptions = [qoeSummary, ...groupOptions.slice(1, 2), abrWithIframe, ...groupOptions.slice(3), qoeSection];
                    } else {
                        this.handleUncheckSectionColumn(qoeSection.text, qoeSection.columns, allColumns, true);
                    }

                    if (oauth.DAILicensePresent) {
                        groupOptions = [...groupOptions, daiSection];
                    } else {
                        this.handleUncheckSectionColumn(daiSection.text, daiSection.columns, allColumns, false);
                    }

                    return (
                        <React.Fragment>
                            <div className="pageTitle displayflex min-width1152">
                                    <div className="page-title-block">
                                        <div className="iq-temp-key-val">
                                            <div className="iq-temp-val page-title-text"> Census</div>
                                        </div>
                                    </div>
                                    <div className="iq-temp-key-val">
                                        <div className="iq-temp-key">Streams Max</div>
                                        <div className="iq-temp-val"> {oauth.sys ? oauth.sys.licenseFlowLimit : '-'}</div>
                                    </div>
                                    <div className="iq-temp-key-val">
                                        <div className="iq-temp-key">Active Streams</div>
                                        <div className="iq-temp-val"> {oauth.sys ? oauth.sys.activeStreams : '-'}</div>
                                    </div>
                                <div className="floatRight">
                                    <UpdateList
                                        refresh={this.state.refreshRate}
                                        onChange={(interval: number | undefined) => this.setRefreshIntervalInCache(interval)}
                                    />
                                <ScanScheduleControl scan schedule />
                                </div>
                            </div>
                            <div className="filterPanel">
                                <Input
                                    className="censusPageSearchBox"
                                    placeholder="Stream Name"
                                    value={this.state.streamName}
                                    onChange={(event, data) => this.setState({streamName: data.value})}
                                    icon={!this.state.streamName ? <Icon /> : <Icon name="delete" link onClick={() => this.setState({streamName: ''})} />}
                                />
                                <SetFilter
                                    onChange={(event: any, data: any) => this.setState({setFilter: data.value})}
                                    setFilter={this.state.setFilter}
                                />
                                <Dropdown
                                    className="censusDropDown"
                                    placeholder="Status"
                                    clearable
                                    search
                                    selection
                                    options={statusOptions}
                                    value={this.state.statusFilter}
                                    onChange={(event, data) => this.setState({statusFilter: data.value})}
                                />
                                <Dropdown
                                    className="censusDropDown"
                                    placeholder="Type"
                                    clearable
                                    search
                                    selection
                                    options={formatOptions}
                                    value={this.state.formatFilter}
                                    onChange={(event, data) => this.setState({formatFilter: data.value})}
                                />
                                <Dropdown
                                    className="censusDropDown"
                                    placeholder="Initiator"
                                    clearable
                                    search
                                    selection
                                    options={initiatorOptions}
                                    value={this.state.initiatorFilter}
                                    onChange={(event, data) => this.setState({initiatorFilter: data.value})}
                                />
                                <Dropdown
                                    className="censusDropDown floatRight censusDropDownColumns"
                                    placeholder="Columns"
                                    // multiple
                                    selection
                                    search
                                    labeled={false}
                                    searchInput={false}
                                    direction={'left'}
                                    wrapSelection
                                    floating
                                    text="Columns"
                                >
                                <Dropdown.Menu className="censusDropDownColumnsMenu" >
                                    <div className="spacerFS"/>
                                    <Checkbox
                                        className="filter-panel-checkbox"
                                        label={<label className="" style={{backgroundColor: 'rgba(255,255,255, 0)'}}>
                                            {'All Columns'}
                                        </label>}
                                        style={{marginLeft: '35px'}}
                                        name={'All Columns'}
                                        checked={this.checkIfAllColumnsAreChecked(groupOptions, allColumns)}
                                        onChange={(e: any, data: any) => this.handleAllColumnsChecked(data, groupOptions, allColumns)}
                                    />
                                    <Button
                                        className="filterPanel-primary-btn floatRight"
                                        content="Reset to Default"
                                        onClick={() => this.setDefaultColumns(allColumns, false)}
                                        style={{marginRight: '75px'}}
                                    />
                                    <div className="spacerFS"/>
                                    {groupOptions.map(cols => {
                                        return <React.Fragment key={cols.text}>
                                            <fieldset className="field-set censusDropDownColumnsFieldset" >
                                            <legend>
                                                <span style={{marginLeft: '5px'}} >
                                                <Checkbox
                                                    label={<label className="" style={{backgroundColor: 'rgba(255,255,255, 0)'}}>
                                                      {cols.text}
                                                    </label>}
                                                    name={cols.text}
                                                    checked={this.checkIfSectionColumnsAreChecked(cols.text, cols.columns, allColumns)}
                                                    onChange={(event, data) => this.handleCheckedSectionColumn(data, cols.text, cols.columns, allColumns)}
                                                />
                                                </span>
                                            </legend>
                                                <Grid columns={4} >
                                                {cols.columns.map((sumCol, index) => {
                                                    return <Grid.Column key={sumCol.text}><Dropdown.Item>
                                                        <Checkbox
                                                            label={<label className="" style={{backgroundColor: 'rgba(255,255,255, 0)'}}>
                                                                        {sumCol.text}
                                                            </label>}
                                                            name={sumCol.text}
                                                            checked={this.checkIfColumnSelected(cols.text, sumCol.id, allColumns)}
                                                            onChange={(event, data) => this.handleCheckedColumn(data, cols.text, sumCol, allColumns, index)}
                                                            style={{width: '100%'}}
                                                        />
                                                    </Dropdown.Item></Grid.Column>;
                                                })}
                                        </Grid></fieldset>
                                        <div className="spacerFS"/>
                                        </React.Fragment>;
                                    })}
                                    </Dropdown.Menu>
                                </Dropdown>
                                {/*<Checkbox*/}
                                {/*    className="filter-panel-checkbox"*/}
                                {/*    label="Show Top Level"*/}
                                {/*    checked={this.state.showTopLevel}*/}
                                {/*    onChange={(e: any, data: any) => this.setShowTopLevelInCache(data.checked)}*/}
                                {/*/>*/}
                                {/*<Button className="filterPanel-primary-btn" content="Filter" onClick={() => this.handleFilter()}/>*/}
                                {/*<Button className="filterPanel-secondary-btn" content="Reset" onClick={() => this.handleReset()}/>*/}
                                {/*<Group.Set*/}
                                {/*    className="column-groups"*/}
                                {/*    defaultChecked={false}*/}
                                {/*    onChange={(set: Array<string>) => this.groupSetRenderer(set)}*/}
                                {/*>*/}
                                {/*    {(oauth.QoELicensePresent && oauth.DAILicensePresent) ?*/}
                                {/*        groupOptionsQoEandDAI.map((column: any, id: number) => {*/}
                                {/*            if (this.state.columns) {*/}
                                {/*                if (this.state.columns.includes(column.key)) {*/}
                                {/*                    return <Group.Field key={id} id={column.key} defaultValue={true}>{column.value}</Group.Field>;*/}
                                {/*                } else return <Group.Field key={id} id={column.key} defaultValue={false}>{column.value}</Group.Field>;*/}
                                {/*            }*/}
                                {/*            return <Group.Field id="Summary" key="Summary" defaultValue={true}>Summary</Group.Field>;*/}
                                {/*        }) : (oauth.QoELicensePresent) ?*/}
                                {/*            groupOptionsQoEOnly.map((column: any, id: number) => {*/}
                                {/*                if (this.state.columns) {*/}
                                {/*                    if (this.state.columns.includes(column.key)) {*/}
                                {/*                        return <Group.Field key={id} id={column.key} defaultValue={true}>{column.value}</Group.Field>;*/}
                                {/*                    } else return <Group.Field key={id} id={column.key} defaultValue={false}>{column.value}</Group.Field>;*/}
                                {/*                }*/}
                                {/*                return <Group.Field id="Summary" key="Summary" defaultValue={true}>Summary</Group.Field>;*/}
                                {/*            }) : (oauth.DAILicensePresent) ?*/}
                                {/*                groupOptionsDAIOnly.map((column: any, id: number) => {*/}
                                {/*                    if (this.state.columns) {*/}
                                {/*                        if (this.state.columns.includes(column.key)) {*/}
                                {/*                            return <Group.Field key={id} id={column.key} defaultValue={true}>{column.value}</Group.Field>;*/}
                                {/*                        } else return <Group.Field key={id} id={column.key} defaultValue={false}>{column.value}</Group.Field>;*/}
                                {/*                    }*/}
                                {/*                    return <Group.Field id="Summary" key="Summary" defaultValue={true}>Summary</Group.Field>;*/}
                                {/*                }) :*/}
                                {/*                    groupOptions.map((column: any, id: number) => {*/}
                                {/*                        if (this.state.columns) {*/}
                                {/*                            if (this.state.columns.includes(column.key)) {*/}
                                {/*                                return <Group.Field key={id} id={column.key} defaultValue={true}>{column.value}</Group.Field>;*/}
                                {/*                            } else return <Group.Field key={id} id={column.key} defaultValue={false}>{column.value}</Group.Field>;*/}
                                {/*                        }*/}
                                {/*                        return <Group.Field id="Summary" key="Summary" defaultValue={true}>Summary</Group.Field>;*/}
                                {/*    })}*/}
                                {/*</Group.Set>*/}

                                <PortalView active={this.state && this.state.showMIMEHeaderWindow} closeWindowPortal={this.closeMIMEHeaderWindowPortal} size="large" data-tip="MIME Headers" title="MIME Headers" >
                                    <MIMEHeaderView streamid={this.state.streamIdForPopup} streamName={this.state.streamNameForPopup} url={this.state.url}/>
                                </PortalView>

                                <PortalView active={this.state && this.state.showMediaFileWindow} closeWindowPortal={this.closeMediaFileWindowPortal} size="fullscreen" data-tip="Media File Statistics" title="Media Statistics" >
                                    <MediaFileView
                                        streamid={this.state.streamIdForPopup}
                                        streamName={this.state.streamNameForPopup}
                                        mode={this.state.mode}
                                        audioEnabled={this.state.audioEnabled}
                                        videoEnabled={this.state.videoEnabled}
                                        pixelEnabled={this.state.pixelEnabled}
                                    />
                                </PortalView>

                                <PortalView active={this.state && this.state.showManifestWindow} closeWindowPortal={this.closeManifestWindowPortal} data-tip="Playlist/Manifest Files" title="Playlist/Manifest" >
                                    {/* tslint:disable-next-line:max-line-length */}
                                    <ManifestView streamid={this.state.streamIdForPopup} streamName={this.state.streamNameForPopup} url={this.state.url} sharedManifest={this.state.sharedManifest} streamType={this.state.streamType} masterFile={this.state.masterFile} />
                                </PortalView>

                                <PortalView active={this.state && this.state.showTextTracksWindow} closeWindowPortal={this.closeTextTracksWindowPortal} data-tip="Text Tracks" title="Text Tracks" >
                                    <TextView streamid={this.state.streamIdForPopup} streamName={this.state.streamNameForPopup} url={this.state.url}/>
                                </PortalView>

                            </div>
                            <Dimmer.Dimmable className="view-clientarea">
                                <OAuth.Context>
                                    {(oauth2: OAuthClientStatus) => (
                                        <Dimmer className="darker-style" active={oauth2.sys && oauth2.sys.interface === 'vod'}>Probe is running VOD tests, Live monitoring is suspended</Dimmer>
                                    )}
                                </OAuth.Context>
                                <DataExportView
                                    // columnSets={this.columnSets}
                                    columnSets={allColumns}
                                    groups={this.state.columns}
                                    filter={this.state.censusFilter}
                                    refreshRate={this.state.tempRefreshRate === 0 ? this.state.refreshRate : this.state.tempRefreshRate}
                                    streamName={this.state.streamName}
                                    setFilter={this.state.setFilter}
                                    statusFilter={this.state.statusFilter}
                                    formatFilter={this.state.formatFilter}
                                    initiatorFilter={this.state.initiatorFilter}
                                    showTopLevel={this.state.showTopLevel} // true
                                    filters={this.computeFilters()}
                                    onDataUpdated={this.onDataUpdated}
                                    treeOrder={this.state.treeOrder} // true
                                />
                            </Dimmer.Dimmable>
                        </React.Fragment>
                    );
                }}

            </OAuth.Context>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/census.tsx